// Auto-generated from traning_result_202602130953.txt
// Generated at: 2026-02-13T03:57:54.645Z
// LSTM: 154 models, AE: 147 models

export function generateMockTrainingHistory(modelId, modelType) {
  const allModels = modelType === 'ae' ? MOCK_PERFORMANCE_SUMMARY.ae.models : MOCK_PERFORMANCE_SUMMARY.lstm.models;
  const model = allModels.find(m => m.model_id === modelId);
  if (!model) return { model_id: modelId, epochs: [] };

  const finalLoss = model.best_val_loss || 0.05;
  const epochs = [];
  const totalEpochs = 50;
  for (let i = 1; i <= totalEpochs; i++) {
    const progress = i / totalEpochs;
    const decay = Math.exp(-3 * progress);
    const trainLoss = finalLoss * 0.8 + (1 - finalLoss * 0.8) * decay * 0.5 + (Math.random() - 0.5) * 0.005;
    const valLoss = finalLoss + (1 - finalLoss) * decay * 0.5 + (Math.random() - 0.5) * 0.01;
    epochs.push({
      epoch: i,
      train_loss: Math.max(0.001, +trainLoss.toFixed(6)),
      val_loss: Math.max(0.001, +valLoss.toFixed(6))
    });
  }
  return { model_id: modelId, model_type: modelType, epochs };
}

export const MOCK_PERFORMANCE_SUMMARY = {
  lstm: {
    total_count: 154,
    avg_val_loss: 0.14,
    avg_accuracy: 99.6,
    avg_precision: 95.99,
    avg_recall: 96.95,
    avg_f1: 96.17,
    avg_fpr: 0.26,
    total_data: 5329174,
    models: [
  {
    "model_id": "opcua_multi_35_DN8-GEAR4",
    "model_type": "lstm",
    "equipment": "opcua_multi_35",
    "craft_id": "DN8-GEAR4",
    "data_size": 71960,
    "best_val_loss": 0.046632386887511965,
    "threshold": 0.09426647387444972,
    "trained_at": "2026-02-12T21:22:13.063710",
    "confusion_matrix": {
      "total_samples": 14383,
      "TP": 698,
      "FP": 0,
      "TN": 13663,
      "FN": 22,
      "accuracy": 99.85,
      "precision": 100,
      "recall": 96.94,
      "f1_score": 98.45,
      "FPR": 0,
      "threshold_used": 0.09426647387444972,
      "val_threshold": 0.09065214693546293
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_11",
    "model_type": "lstm",
    "equipment": "opcua_multi_02",
    "craft_id": "11",
    "data_size": 1333,
    "best_val_loss": 0.048936863600164075,
    "threshold": 0.20629565417766568,
    "trained_at": "2026-02-12T23:00:00.702408",
    "confusion_matrix": {
      "total_samples": 257,
      "TP": 13,
      "FP": 5,
      "TN": 239,
      "FN": 0,
      "accuracy": 98.05,
      "precision": 72.22,
      "recall": 100,
      "f1_score": 83.87,
      "FPR": 2.05,
      "threshold_used": 0.20629565417766568,
      "val_threshold": 0.286954629421234
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_24_130",
    "model_type": "lstm",
    "equipment": "opcua_multi_24",
    "craft_id": "130",
    "data_size": 39397,
    "best_val_loss": 0.04980348549319344,
    "threshold": 0.25193106830120066,
    "trained_at": "2026-02-12T21:13:26.900178",
    "confusion_matrix": {
      "total_samples": 7870,
      "TP": 371,
      "FP": 0,
      "TN": 7476,
      "FN": 23,
      "accuracy": 99.71,
      "precision": 100,
      "recall": 94.16,
      "f1_score": 96.99,
      "FPR": 0,
      "threshold_used": 0.25193106830120066,
      "val_threshold": 0.24021254181861865
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_14_97-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_14",
    "craft_id": "97-2",
    "data_size": 87740,
    "best_val_loss": 0.05019527216752512,
    "threshold": 0.027071324829012155,
    "trained_at": "2026-02-12T20:30:39.030482",
    "confusion_matrix": {
      "total_samples": 17539,
      "TP": 852,
      "FP": 0,
      "TN": 16662,
      "FN": 25,
      "accuracy": 99.86,
      "precision": 100,
      "recall": 97.15,
      "f1_score": 98.55,
      "FPR": 0,
      "threshold_used": 0.027071324829012155,
      "val_threshold": 0.026904076151549796
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_25-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_07",
    "craft_id": "25-1",
    "data_size": 62770,
    "best_val_loss": 0.05477659519778133,
    "threshold": 0.0646205972880125,
    "trained_at": "2026-02-12T21:58:33.013513",
    "confusion_matrix": {
      "total_samples": 12545,
      "TP": 603,
      "FP": 0,
      "TN": 11917,
      "FN": 25,
      "accuracy": 99.8,
      "precision": 100,
      "recall": 96.02,
      "f1_score": 97.97,
      "FPR": 0,
      "threshold_used": 0.0646205972880125,
      "val_threshold": 0.060379338264465315
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_22_109",
    "model_type": "lstm",
    "equipment": "opcua_multi_22",
    "craft_id": "109",
    "data_size": 77744,
    "best_val_loss": 0.061895308106182566,
    "threshold": 0.15584106370806694,
    "trained_at": "2026-02-12T20:43:12.678418",
    "confusion_matrix": {
      "total_samples": 15539,
      "TP": 756,
      "FP": 0,
      "TN": 14762,
      "FN": 21,
      "accuracy": 99.86,
      "precision": 100,
      "recall": 97.3,
      "f1_score": 98.63,
      "FPR": 0,
      "threshold_used": 0.15584106370806694,
      "val_threshold": 0.15364752709865567
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_74",
    "model_type": "lstm",
    "equipment": "opcua_multi_40",
    "craft_id": "74",
    "data_size": 42774,
    "best_val_loss": 0.062099328965947005,
    "threshold": 0.07430993802845477,
    "trained_at": "2026-02-12T21:23:17.032110",
    "confusion_matrix": {
      "total_samples": 8545,
      "TP": 428,
      "FP": 26,
      "TN": 8091,
      "FN": 0,
      "accuracy": 99.7,
      "precision": 94.27,
      "recall": 100,
      "f1_score": 97.05,
      "FPR": 0.32,
      "threshold_used": 0.07430993802845477,
      "val_threshold": 0.091832736134529
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_56",
    "model_type": "lstm",
    "equipment": "opcua_multi_18",
    "craft_id": "56",
    "data_size": 9493,
    "best_val_loss": 0.06421011728873055,
    "threshold": 0.059755593165755266,
    "trained_at": "2026-02-12T22:53:05.953122",
    "confusion_matrix": {
      "total_samples": 1889,
      "TP": 85,
      "FP": 0,
      "TN": 1794,
      "FN": 10,
      "accuracy": 99.47,
      "precision": 100,
      "recall": 89.47,
      "f1_score": 94.44,
      "FPR": 0,
      "threshold_used": 0.059755593165755266,
      "val_threshold": 0.05697674900293346
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_33",
    "model_type": "lstm",
    "equipment": "opcua_multi_34",
    "craft_id": "33",
    "data_size": 39823,
    "best_val_loss": 0.06783916819571399,
    "threshold": 0.15748622268438323,
    "trained_at": "2026-02-12T21:53:59.699319",
    "confusion_matrix": {
      "total_samples": 7955,
      "TP": 398,
      "FP": 19,
      "TN": 7538,
      "FN": 0,
      "accuracy": 99.76,
      "precision": 95.44,
      "recall": 100,
      "f1_score": 97.67,
      "FPR": 0.25,
      "threshold_used": 0.15748622268438323,
      "val_threshold": 0.16078853160142897
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_103",
    "model_type": "lstm",
    "equipment": "opcua_multi_19",
    "craft_id": "103",
    "data_size": 25739,
    "best_val_loss": 0.07299810919857015,
    "threshold": 0.14616746529936805,
    "trained_at": "2026-02-12T22:37:25.713138",
    "confusion_matrix": {
      "total_samples": 5138,
      "TP": 252,
      "FP": 0,
      "TN": 4881,
      "FN": 5,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 98.05,
      "f1_score": 99.02,
      "FPR": 0,
      "threshold_used": 0.14616746529936805,
      "val_threshold": 0.14489094093441962
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_QV-HOUSING",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "QV-HOUSING",
    "data_size": 5047,
    "best_val_loss": 0.07365090882778168,
    "threshold": 0.4465766534209251,
    "trained_at": "2026-02-12T23:21:45.783100",
    "confusion_matrix": {
      "total_samples": 1000,
      "TP": 50,
      "FP": 2,
      "TN": 948,
      "FN": 0,
      "accuracy": 99.8,
      "precision": 96.15,
      "recall": 100,
      "f1_score": 98.04,
      "FPR": 0.21,
      "threshold_used": 0.4465766534209251,
      "val_threshold": 0.448631228506565
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_21_66",
    "model_type": "lstm",
    "equipment": "opcua_multi_21",
    "craft_id": "66",
    "data_size": 136320,
    "best_val_loss": 0.07837354276234285,
    "threshold": 0.14450964331626892,
    "trained_at": "2026-02-12T20:37:14.858316",
    "confusion_matrix": {
      "total_samples": 27255,
      "TP": 1363,
      "FP": 21,
      "TN": 25871,
      "FN": 0,
      "accuracy": 99.92,
      "precision": 98.48,
      "recall": 100,
      "f1_score": 99.23,
      "FPR": 0.08,
      "threshold_used": 0.14450964331626892,
      "val_threshold": 0.14540472626686093
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_68",
    "model_type": "lstm",
    "equipment": "opcua_multi_19",
    "craft_id": "68",
    "data_size": 79941,
    "best_val_loss": 0.0798280122639487,
    "threshold": 0.21233100593090037,
    "trained_at": "2026-02-12T20:57:15.789816",
    "confusion_matrix": {
      "total_samples": 15979,
      "TP": 799,
      "FP": 8,
      "TN": 15172,
      "FN": 0,
      "accuracy": 99.95,
      "precision": 99.01,
      "recall": 100,
      "f1_score": 99.5,
      "FPR": 0.05,
      "threshold_used": 0.21233100593090037,
      "val_threshold": 0.21376761347055395
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_75",
    "model_type": "lstm",
    "equipment": "opcua_multi_40",
    "craft_id": "75",
    "data_size": 35877,
    "best_val_loss": 0.08402842384412938,
    "threshold": 0.08633786477148477,
    "trained_at": "2026-02-12T22:41:04.939843",
    "confusion_matrix": {
      "total_samples": 7166,
      "TP": 359,
      "FP": 3,
      "TN": 6804,
      "FN": 0,
      "accuracy": 99.96,
      "precision": 99.17,
      "recall": 100,
      "f1_score": 99.58,
      "FPR": 0.04,
      "threshold_used": 0.08633786477148477,
      "val_threshold": 0.08765874430537224
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_31_67-3",
    "model_type": "lstm",
    "equipment": "opcua_multi_31",
    "craft_id": "67-3",
    "data_size": 113317,
    "best_val_loss": 0.08580398932000677,
    "threshold": 0.06861113309860227,
    "trained_at": "2026-02-12T20:49:10.364641",
    "confusion_matrix": {
      "total_samples": 22654,
      "TP": 1106,
      "FP": 0,
      "TN": 21521,
      "FN": 27,
      "accuracy": 99.88,
      "precision": 100,
      "recall": 97.62,
      "f1_score": 98.8,
      "FPR": 0,
      "threshold_used": 0.06861113309860227,
      "val_threshold": 0.06707863509654993
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_24",
    "model_type": "lstm",
    "equipment": "opcua_multi_07",
    "craft_id": "24",
    "data_size": 91195,
    "best_val_loss": 0.08581747634359853,
    "threshold": 0.0411814795807004,
    "trained_at": "2026-02-12T21:17:46.488659",
    "confusion_matrix": {
      "total_samples": 18230,
      "TP": 912,
      "FP": 5,
      "TN": 17313,
      "FN": 0,
      "accuracy": 99.97,
      "precision": 99.45,
      "recall": 100,
      "f1_score": 99.72,
      "FPR": 0.03,
      "threshold_used": 0.0411814795807004,
      "val_threshold": 0.041234982572495936
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_72",
    "model_type": "lstm",
    "equipment": "opcua_multi_07",
    "craft_id": "72",
    "data_size": 7393,
    "best_val_loss": 0.08833756036625337,
    "threshold": 0.12732580155134207,
    "trained_at": "2026-02-12T23:17:52.087928",
    "confusion_matrix": {
      "total_samples": 1469,
      "TP": 74,
      "FP": 27,
      "TN": 1368,
      "FN": 0,
      "accuracy": 98.16,
      "precision": 73.27,
      "recall": 100,
      "f1_score": 84.57,
      "FPR": 1.94,
      "threshold_used": 0.12732580155134207,
      "val_threshold": 0.13086293935775756
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_94-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_10",
    "craft_id": "94-1",
    "data_size": 19506,
    "best_val_loss": 0.0887404262161941,
    "threshold": 0.13149494528770447,
    "trained_at": "2026-02-12T20:53:44.518909",
    "confusion_matrix": {
      "total_samples": 3892,
      "TP": 187,
      "FP": 0,
      "TN": 3697,
      "FN": 8,
      "accuracy": 99.79,
      "precision": 100,
      "recall": 95.9,
      "f1_score": 97.91,
      "FPR": 0,
      "threshold_used": 0.13149494528770447,
      "val_threshold": 0.13024679645895956
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_05_65-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_05",
    "craft_id": "65-2",
    "data_size": 40690,
    "best_val_loss": 0.0890102547231724,
    "threshold": 0.16672548130154594,
    "trained_at": "2026-02-12T22:36:23.594541",
    "confusion_matrix": {
      "total_samples": 8129,
      "TP": 401,
      "FP": 0,
      "TN": 7722,
      "FN": 6,
      "accuracy": 99.93,
      "precision": 100,
      "recall": 98.53,
      "f1_score": 99.26,
      "FPR": 0,
      "threshold_used": 0.16672548130154594,
      "val_threshold": 0.1655092597007751
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_70",
    "model_type": "lstm",
    "equipment": "opcua_multi_34",
    "craft_id": "70",
    "data_size": 7831,
    "best_val_loss": 0.08985649300027368,
    "threshold": 0.2260272860527027,
    "trained_at": "2026-02-12T22:46:29.511868",
    "confusion_matrix": {
      "total_samples": 1557,
      "TP": 64,
      "FP": 0,
      "TN": 1479,
      "FN": 14,
      "accuracy": 99.1,
      "precision": 100,
      "recall": 82.05,
      "f1_score": 90.14,
      "FPR": 0,
      "threshold_used": 0.2260272860527027,
      "val_threshold": 0.20154250562191
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_03_64",
    "model_type": "lstm",
    "equipment": "opcua_multi_03",
    "craft_id": "64",
    "data_size": 108642,
    "best_val_loss": 0.0903718726153496,
    "threshold": 0.09698930308222768,
    "trained_at": "2026-02-12T19:59:04.697141",
    "confusion_matrix": {
      "total_samples": 21719,
      "TP": 1086,
      "FP": 55,
      "TN": 20578,
      "FN": 0,
      "accuracy": 99.75,
      "precision": 95.18,
      "recall": 100,
      "f1_score": 97.53,
      "FPR": 0.27,
      "threshold_used": 0.09698930308222768,
      "val_threshold": 0.09773655310273169
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_134",
    "model_type": "lstm",
    "equipment": "opcua_multi_06",
    "craft_id": "134",
    "data_size": 55022,
    "best_val_loss": 0.09149459312996468,
    "threshold": 0.1290307424962522,
    "trained_at": "2026-02-12T21:58:47.592167",
    "confusion_matrix": {
      "total_samples": 10995,
      "TP": 549,
      "FP": 0,
      "TN": 10445,
      "FN": 1,
      "accuracy": 99.99,
      "precision": 100,
      "recall": 99.82,
      "f1_score": 99.91,
      "FPR": 0,
      "threshold_used": 0.1290307424962522,
      "val_threshold": 0.12866416573524467
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_28_123",
    "model_type": "lstm",
    "equipment": "opcua_multi_28",
    "craft_id": "123",
    "data_size": 14549,
    "best_val_loss": 0.09183791421610733,
    "threshold": 0.08393915817141531,
    "trained_at": "2026-02-12T23:09:35.472476",
    "confusion_matrix": {
      "total_samples": 2900,
      "TP": 145,
      "FP": 10,
      "TN": 2745,
      "FN": 0,
      "accuracy": 99.66,
      "precision": 93.55,
      "recall": 100,
      "f1_score": 96.67,
      "FPR": 0.36,
      "threshold_used": 0.08393915817141531,
      "val_threshold": 0.08527127616107463
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_26",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "26",
    "data_size": 18759,
    "best_val_loss": 0.09360290058693868,
    "threshold": 0.08034362643957138,
    "trained_at": "2026-02-12T22:43:38.712725",
    "confusion_matrix": {
      "total_samples": 3742,
      "TP": 188,
      "FP": 14,
      "TN": 3540,
      "FN": 0,
      "accuracy": 99.63,
      "precision": 93.07,
      "recall": 100,
      "f1_score": 96.41,
      "FPR": 0.39,
      "threshold_used": 0.08034362643957138,
      "val_threshold": 0.08375282026827328
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_90",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "90",
    "data_size": 3456,
    "best_val_loss": 0.09487229570353135,
    "threshold": 0.2826854705810544,
    "trained_at": "2026-02-12T23:02:53.329893",
    "confusion_matrix": {
      "total_samples": 682,
      "TP": 35,
      "FP": 3,
      "TN": 644,
      "FN": 0,
      "accuracy": 99.56,
      "precision": 92.11,
      "recall": 100,
      "f1_score": 95.89,
      "FPR": 0.46,
      "threshold_used": 0.2826854705810544,
      "val_threshold": 0.3222145587205885
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_120",
    "model_type": "lstm",
    "equipment": "opcua_multi_18",
    "craft_id": "120",
    "data_size": 26454,
    "best_val_loss": 0.09652005932001967,
    "threshold": 0.1064206805080175,
    "trained_at": "2026-02-12T22:01:22.583126",
    "confusion_matrix": {
      "total_samples": 5281,
      "TP": 264,
      "FP": 20,
      "TN": 4997,
      "FN": 0,
      "accuracy": 99.62,
      "precision": 92.96,
      "recall": 100,
      "f1_score": 96.35,
      "FPR": 0.4,
      "threshold_used": 0.1064206805080175,
      "val_threshold": 0.11056472361087799
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_28_K2XX-GEAR5",
    "model_type": "lstm",
    "equipment": "opcua_multi_28",
    "craft_id": "K2XX-GEAR5",
    "data_size": 23026,
    "best_val_loss": 0.09804428361673995,
    "threshold": 0.202198326587677,
    "trained_at": "2026-02-12T20:46:04.877560",
    "confusion_matrix": {
      "total_samples": 4596,
      "TP": 202,
      "FP": 0,
      "TN": 4366,
      "FN": 28,
      "accuracy": 99.39,
      "precision": 100,
      "recall": 87.83,
      "f1_score": 93.52,
      "FPR": 0,
      "threshold_used": 0.202198326587677,
      "val_threshold": 0.18235746771097183
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_67-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_32",
    "craft_id": "67-1",
    "data_size": 9410,
    "best_val_loss": 0.09809629387608583,
    "threshold": 0.2183814421296118,
    "trained_at": "2026-02-12T21:40:07.597821",
    "confusion_matrix": {
      "total_samples": 1873,
      "TP": 85,
      "FP": 0,
      "TN": 1779,
      "FN": 9,
      "accuracy": 99.52,
      "precision": 100,
      "recall": 90.43,
      "f1_score": 94.97,
      "FPR": 0,
      "threshold_used": 0.2183814421296118,
      "val_threshold": 0.21584299206733704
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_26_109",
    "model_type": "lstm",
    "equipment": "opcua_multi_26",
    "craft_id": "109",
    "data_size": 113290,
    "best_val_loss": 0.10064019771442728,
    "threshold": 0.08217524588108055,
    "trained_at": "2026-02-12T21:02:19.036569",
    "confusion_matrix": {
      "total_samples": 22649,
      "TP": 1065,
      "FP": 0,
      "TN": 21516,
      "FN": 68,
      "accuracy": 99.7,
      "precision": 100,
      "recall": 94,
      "f1_score": 96.91,
      "FPR": 0,
      "threshold_used": 0.08217524588108055,
      "val_threshold": 0.07813956290483474
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_92",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "92",
    "data_size": 15427,
    "best_val_loss": 0.10169095438463015,
    "threshold": 0.13871929571032518,
    "trained_at": "2026-02-12T23:08:42.183031",
    "confusion_matrix": {
      "total_samples": 3076,
      "TP": 133,
      "FP": 0,
      "TN": 2922,
      "FN": 21,
      "accuracy": 99.32,
      "precision": 100,
      "recall": 86.36,
      "f1_score": 92.68,
      "FPR": 0,
      "threshold_used": 0.13871929571032518,
      "val_threshold": 0.13540511578321457
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_105",
    "model_type": "lstm",
    "equipment": "opcua_multi_19",
    "craft_id": "105",
    "data_size": 16586,
    "best_val_loss": 0.10258076562486508,
    "threshold": 0.10511521399021147,
    "trained_at": "2026-02-12T23:04:35.427175",
    "confusion_matrix": {
      "total_samples": 3308,
      "TP": 154,
      "FP": 0,
      "TN": 3142,
      "FN": 12,
      "accuracy": 99.64,
      "precision": 100,
      "recall": 92.77,
      "f1_score": 96.25,
      "FPR": 0,
      "threshold_used": 0.10511521399021147,
      "val_threshold": 0.10457913205027579
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_71",
    "model_type": "lstm",
    "equipment": "opcua_multi_34",
    "craft_id": "71",
    "data_size": 55927,
    "best_val_loss": 0.10345816594643856,
    "threshold": 0.4190322563052172,
    "trained_at": "2026-02-12T21:08:29.088824",
    "confusion_matrix": {
      "total_samples": 11176,
      "TP": 559,
      "FP": 23,
      "TN": 10594,
      "FN": 0,
      "accuracy": 99.79,
      "precision": 96.05,
      "recall": 100,
      "f1_score": 97.99,
      "FPR": 0.22,
      "threshold_used": 0.4190322563052172,
      "val_threshold": 0.42993899434804916
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_62-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_02",
    "craft_id": "62-2",
    "data_size": 12364,
    "best_val_loss": 0.10408575148285766,
    "threshold": 0.2375845737755286,
    "trained_at": "2026-02-12T22:43:00.800764",
    "confusion_matrix": {
      "total_samples": 2463,
      "TP": 115,
      "FP": 0,
      "TN": 2339,
      "FN": 9,
      "accuracy": 99.63,
      "precision": 100,
      "recall": 92.74,
      "f1_score": 96.23,
      "FPR": 0,
      "threshold_used": 0.2375845737755286,
      "val_threshold": 0.22403059601783762
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_13_33",
    "model_type": "lstm",
    "equipment": "opcua_multi_13",
    "craft_id": "33",
    "data_size": 6697,
    "best_val_loss": 0.10461249090451047,
    "threshold": 0.20542411953210823,
    "trained_at": "2026-02-12T21:04:14.030136",
    "confusion_matrix": {
      "total_samples": 1330,
      "TP": 67,
      "FP": 10,
      "TN": 1253,
      "FN": 0,
      "accuracy": 99.25,
      "precision": 87.01,
      "recall": 100,
      "f1_score": 93.05,
      "FPR": 0.79,
      "threshold_used": 0.20542411953210823,
      "val_threshold": 0.2429125308990478
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_16_27",
    "model_type": "lstm",
    "equipment": "opcua_multi_16",
    "craft_id": "27",
    "data_size": 3302,
    "best_val_loss": 0.10524686974131384,
    "threshold": 0.23500345647335025,
    "trained_at": "2026-02-12T22:46:26.477757",
    "confusion_matrix": {
      "total_samples": 651,
      "TP": 32,
      "FP": 0,
      "TN": 618,
      "FN": 1,
      "accuracy": 99.85,
      "precision": 100,
      "recall": 96.97,
      "f1_score": 98.46,
      "FPR": 0,
      "threshold_used": 0.23500345647335025,
      "val_threshold": 0.23301491886377335
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_72",
    "model_type": "lstm",
    "equipment": "opcua_multi_09",
    "craft_id": "72",
    "data_size": 9009,
    "best_val_loss": 0.10648996609130076,
    "threshold": 0.17874844446778293,
    "trained_at": "2026-02-12T23:16:47.239911",
    "confusion_matrix": {
      "total_samples": 1792,
      "TP": 74,
      "FP": 0,
      "TN": 1702,
      "FN": 16,
      "accuracy": 99.11,
      "precision": 100,
      "recall": 82.22,
      "f1_score": 90.24,
      "FPR": 0,
      "threshold_used": 0.17874844446778293,
      "val_threshold": 0.16966794356703757
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_112",
    "model_type": "lstm",
    "equipment": "opcua_multi_02",
    "craft_id": "112",
    "data_size": 35384,
    "best_val_loss": 0.10935752295159004,
    "threshold": 0.1039999172091484,
    "trained_at": "2026-02-12T21:29:26.911764",
    "confusion_matrix": {
      "total_samples": 7067,
      "TP": 354,
      "FP": 16,
      "TN": 6697,
      "FN": 0,
      "accuracy": 99.77,
      "precision": 95.68,
      "recall": 100,
      "f1_score": 97.79,
      "FPR": 0.24,
      "threshold_used": 0.1039999172091484,
      "val_threshold": 0.10605607703328132
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_27",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "27",
    "data_size": 11166,
    "best_val_loss": 0.11010016634953108,
    "threshold": 0.1922688245773315,
    "trained_at": "2026-02-12T23:14:10.289056",
    "confusion_matrix": {
      "total_samples": 2224,
      "TP": 112,
      "FP": 1,
      "TN": 2111,
      "FN": 0,
      "accuracy": 99.96,
      "precision": 99.12,
      "recall": 100,
      "f1_score": 99.56,
      "FPR": 0.05,
      "threshold_used": 0.1922688245773315,
      "val_threshold": 0.1928669467568397
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_60-3",
    "model_type": "lstm",
    "equipment": "opcua_multi_27",
    "craft_id": "60-3",
    "data_size": 1573,
    "best_val_loss": 0.1105141742551913,
    "threshold": 0.2686307966709137,
    "trained_at": "2026-02-12T23:21:24.447738",
    "confusion_matrix": {
      "total_samples": 305,
      "TP": 16,
      "FP": 6,
      "TN": 283,
      "FN": 0,
      "accuracy": 98.03,
      "precision": 72.73,
      "recall": 100,
      "f1_score": 84.21,
      "FPR": 2.08,
      "threshold_used": 0.2686307966709137,
      "val_threshold": 0.2863996922969818
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_34",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "34",
    "data_size": 17310,
    "best_val_loss": 0.1108181282765721,
    "threshold": 0.1562767080962658,
    "trained_at": "2026-02-12T23:02:26.079443",
    "confusion_matrix": {
      "total_samples": 3453,
      "TP": 173,
      "FP": 0,
      "TN": 3280,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.1562767080962658,
      "val_threshold": 0.15625106096267682
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_30_13",
    "model_type": "lstm",
    "equipment": "opcua_multi_30",
    "craft_id": "13",
    "data_size": 50942,
    "best_val_loss": 0.11083844011265762,
    "threshold": 0.14103789478540416,
    "trained_at": "2026-02-12T22:20:39.363141",
    "confusion_matrix": {
      "total_samples": 10179,
      "TP": 503,
      "FP": 0,
      "TN": 9670,
      "FN": 6,
      "accuracy": 99.94,
      "precision": 100,
      "recall": 98.82,
      "f1_score": 99.41,
      "FPR": 0,
      "threshold_used": 0.14103789478540416,
      "val_threshold": 0.1388755545020104
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_15_98-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_15",
    "craft_id": "98-2",
    "data_size": 53399,
    "best_val_loss": 0.11177817748644805,
    "threshold": 0.12701499685645096,
    "trained_at": "2026-02-12T19:58:23.771688",
    "confusion_matrix": {
      "total_samples": 10670,
      "TP": 534,
      "FP": 13,
      "TN": 10123,
      "FN": 0,
      "accuracy": 99.88,
      "precision": 97.62,
      "recall": 100,
      "f1_score": 98.8,
      "FPR": 0.13,
      "threshold_used": 0.12701499685645096,
      "val_threshold": 0.12771361768245695
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_04_65",
    "model_type": "lstm",
    "equipment": "opcua_multi_04",
    "craft_id": "65",
    "data_size": 96213,
    "best_val_loss": 0.11307683444710198,
    "threshold": 0.06923890113830566,
    "trained_at": "2026-02-12T20:41:56.915255",
    "confusion_matrix": {
      "total_samples": 19233,
      "TP": 962,
      "FP": 27,
      "TN": 18244,
      "FN": 0,
      "accuracy": 99.86,
      "precision": 97.27,
      "recall": 100,
      "f1_score": 98.62,
      "FPR": 0.15,
      "threshold_used": 0.06923890113830566,
      "val_threshold": 0.07046566158533095
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_29",
    "model_type": "lstm",
    "equipment": "opcua_multi_09",
    "craft_id": "29",
    "data_size": 38868,
    "best_val_loss": 0.11322963182103812,
    "threshold": 0.19772911667823714,
    "trained_at": "2026-02-12T22:05:40.501077",
    "confusion_matrix": {
      "total_samples": 7764,
      "TP": 389,
      "FP": 30,
      "TN": 7345,
      "FN": 0,
      "accuracy": 99.61,
      "precision": 92.84,
      "recall": 100,
      "f1_score": 96.29,
      "FPR": 0.41,
      "threshold_used": 0.19772911667823714,
      "val_threshold": 0.22385514676570814
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_38_114",
    "model_type": "lstm",
    "equipment": "opcua_multi_38",
    "craft_id": "114",
    "data_size": 53765,
    "best_val_loss": 0.11324459990612713,
    "threshold": 0.31574042737483965,
    "trained_at": "2026-02-12T20:34:44.012749",
    "confusion_matrix": {
      "total_samples": 10744,
      "TP": 538,
      "FP": 18,
      "TN": 10188,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.76,
      "recall": 100,
      "f1_score": 98.35,
      "FPR": 0.18,
      "threshold_used": 0.31574042737483965,
      "val_threshold": 0.32723887264728546
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_36_25-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_36",
    "craft_id": "25-1",
    "data_size": 2221,
    "best_val_loss": 0.1133073709648231,
    "threshold": 0.234415516257286,
    "trained_at": "2026-02-12T22:57:40.227554",
    "confusion_matrix": {
      "total_samples": 435,
      "TP": 17,
      "FP": 0,
      "TN": 413,
      "FN": 5,
      "accuracy": 98.85,
      "precision": 100,
      "recall": 77.27,
      "f1_score": 87.18,
      "FPR": 0,
      "threshold_used": 0.234415516257286,
      "val_threshold": 0.22350820153951645
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_104",
    "model_type": "lstm",
    "equipment": "opcua_multi_18",
    "craft_id": "104",
    "data_size": 13585,
    "best_val_loss": 0.1135924494491018,
    "threshold": 0.26111976802349085,
    "trained_at": "2026-02-12T23:11:31.021714",
    "confusion_matrix": {
      "total_samples": 2708,
      "TP": 136,
      "FP": 14,
      "TN": 2558,
      "FN": 0,
      "accuracy": 99.48,
      "precision": 90.67,
      "recall": 100,
      "f1_score": 95.11,
      "FPR": 0.54,
      "threshold_used": 0.26111976802349085,
      "val_threshold": 0.3152940198779109
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_54",
    "model_type": "lstm",
    "equipment": "opcua_multi_18",
    "craft_id": "54",
    "data_size": 46354,
    "best_val_loss": 0.11406883546207033,
    "threshold": 0.10971159152686595,
    "trained_at": "2026-02-12T22:25:19.433606",
    "confusion_matrix": {
      "total_samples": 9261,
      "TP": 463,
      "FP": 43,
      "TN": 8755,
      "FN": 0,
      "accuracy": 99.54,
      "precision": 91.5,
      "recall": 100,
      "f1_score": 95.56,
      "FPR": 0.49,
      "threshold_used": 0.10971159152686595,
      "val_threshold": 0.11366252601146698
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_36",
    "model_type": "lstm",
    "equipment": "opcua_multi_09",
    "craft_id": "36",
    "data_size": 4382,
    "best_val_loss": 0.11503725932028054,
    "threshold": 0.3377757668495178,
    "trained_at": "2026-02-12T22:41:41.190558",
    "confusion_matrix": {
      "total_samples": 867,
      "TP": 40,
      "FP": 0,
      "TN": 823,
      "FN": 4,
      "accuracy": 99.54,
      "precision": 100,
      "recall": 90.91,
      "f1_score": 95.24,
      "FPR": 0,
      "threshold_used": 0.3377757668495178,
      "val_threshold": 0.32601166069507587
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_128",
    "model_type": "lstm",
    "equipment": "opcua_multi_02",
    "craft_id": "128",
    "data_size": 5395,
    "best_val_loss": 0.11520634801866853,
    "threshold": 0.4130459502339363,
    "trained_at": "2026-02-12T23:20:59.076702",
    "confusion_matrix": {
      "total_samples": 1070,
      "TP": 54,
      "FP": 1,
      "TN": 1015,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.18,
      "recall": 100,
      "f1_score": 99.08,
      "FPR": 0.1,
      "threshold_used": 0.4130459502339363,
      "val_threshold": 0.4152996152639389
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_12_31",
    "model_type": "lstm",
    "equipment": "opcua_multi_12",
    "craft_id": "31",
    "data_size": 28894,
    "best_val_loss": 0.11529690167750575,
    "threshold": 0.2669527754187584,
    "trained_at": "2026-02-12T21:49:26.288011",
    "confusion_matrix": {
      "total_samples": 5769,
      "TP": 283,
      "FP": 0,
      "TN": 5480,
      "FN": 6,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 97.92,
      "f1_score": 98.95,
      "FPR": 0,
      "threshold_used": 0.2669527754187584,
      "val_threshold": 0.2647510409355162
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_75",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "75",
    "data_size": 11810,
    "best_val_loss": 0.11651190390269704,
    "threshold": 0.25067490637302325,
    "trained_at": "2026-02-12T23:13:20.539221",
    "confusion_matrix": {
      "total_samples": 2353,
      "TP": 118,
      "FP": 4,
      "TN": 2231,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.72,
      "recall": 100,
      "f1_score": 98.33,
      "FPR": 0.18,
      "threshold_used": 0.25067490637302325,
      "val_threshold": 0.25985236167907716
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_01_MA120IIIE.09",
    "model_type": "lstm",
    "equipment": "opcua_multi_dongtan_01",
    "craft_id": "MA120IIIE.09",
    "data_size": 212960,
    "best_val_loss": 0.11737757548733584,
    "threshold": 0.1501461625099182,
    "trained_at": "2026-02-12T20:23:58.225067",
    "confusion_matrix": {
      "total_samples": 42583,
      "TP": 2130,
      "FP": 74,
      "TN": 40379,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.64,
      "recall": 100,
      "f1_score": 98.29,
      "FPR": 0.18,
      "threshold_used": 0.1501461625099182,
      "val_threshold": 0.15087445080280315
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_72",
    "model_type": "lstm",
    "equipment": "opcua_multi_06",
    "craft_id": "72",
    "data_size": 44172,
    "best_val_loss": 0.11805713237176198,
    "threshold": 0.12417241185903563,
    "trained_at": "2026-02-12T22:34:42.201003",
    "confusion_matrix": {
      "total_samples": 8825,
      "TP": 441,
      "FP": 0,
      "TN": 8383,
      "FN": 1,
      "accuracy": 99.99,
      "precision": 100,
      "recall": 99.77,
      "f1_score": 99.88,
      "FPR": 0,
      "threshold_used": 0.12417241185903563,
      "val_threshold": 0.12384523004293375
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_13_36",
    "model_type": "lstm",
    "equipment": "opcua_multi_13",
    "craft_id": "36",
    "data_size": 58880,
    "best_val_loss": 0.11906703736490915,
    "threshold": 0.15449757799506186,
    "trained_at": "2026-02-12T21:34:12.029149",
    "confusion_matrix": {
      "total_samples": 11767,
      "TP": 563,
      "FP": 0,
      "TN": 11178,
      "FN": 26,
      "accuracy": 99.78,
      "precision": 100,
      "recall": 95.59,
      "f1_score": 97.75,
      "FPR": 0,
      "threshold_used": 0.15449757799506186,
      "val_threshold": 0.14696929901838296
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_34",
    "model_type": "lstm",
    "equipment": "opcua_multi_06",
    "craft_id": "34",
    "data_size": 37248,
    "best_val_loss": 0.11921438042835522,
    "threshold": 0.14779066294431675,
    "trained_at": "2026-02-12T22:40:14.945540",
    "confusion_matrix": {
      "total_samples": 7440,
      "TP": 372,
      "FP": 45,
      "TN": 7023,
      "FN": 0,
      "accuracy": 99.4,
      "precision": 89.21,
      "recall": 100,
      "f1_score": 94.3,
      "FPR": 0.64,
      "threshold_used": 0.14779066294431675,
      "val_threshold": 0.1811437815427762
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_95",
    "model_type": "lstm",
    "equipment": "opcua_multi_20",
    "craft_id": "95",
    "data_size": 5703,
    "best_val_loss": 0.11980638137889267,
    "threshold": 0.18571111410856242,
    "trained_at": "2026-02-12T21:03:11.859600",
    "confusion_matrix": {
      "total_samples": 1131,
      "TP": 57,
      "FP": 0,
      "TN": 1074,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.18571111410856242,
      "val_threshold": 0.1855933666229248
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_104",
    "model_type": "lstm",
    "equipment": "opcua_multi_10",
    "craft_id": "104",
    "data_size": 8457,
    "best_val_loss": 0.12035820672153434,
    "threshold": 0.12760640680789948,
    "trained_at": "2026-02-12T22:47:37.440505",
    "confusion_matrix": {
      "total_samples": 1682,
      "TP": 85,
      "FP": 3,
      "TN": 1594,
      "FN": 0,
      "accuracy": 99.82,
      "precision": 96.59,
      "recall": 100,
      "f1_score": 98.27,
      "FPR": 0.19,
      "threshold_used": 0.12760640680789948,
      "val_threshold": 0.1285813063383102
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_05_11",
    "model_type": "lstm",
    "equipment": "opcua_multi_05",
    "craft_id": "11",
    "data_size": 123876,
    "best_val_loss": 0.12178543885654003,
    "threshold": 0.1868821531534195,
    "trained_at": "2026-02-12T21:05:59.476870",
    "confusion_matrix": {
      "total_samples": 24766,
      "TP": 1228,
      "FP": 0,
      "TN": 23527,
      "FN": 11,
      "accuracy": 99.96,
      "precision": 100,
      "recall": 99.11,
      "f1_score": 99.55,
      "FPR": 0,
      "threshold_used": 0.1868821531534195,
      "val_threshold": 0.18520381674170494
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_86",
    "model_type": "lstm",
    "equipment": "opcua_multi_33",
    "craft_id": "86",
    "data_size": 58324,
    "best_val_loss": 0.12272664516371547,
    "threshold": 0.19246033430099457,
    "trained_at": "2026-02-12T21:17:53.635591",
    "confusion_matrix": {
      "total_samples": 11655,
      "TP": 583,
      "FP": 2,
      "TN": 11070,
      "FN": 0,
      "accuracy": 99.98,
      "precision": 99.66,
      "recall": 100,
      "f1_score": 99.83,
      "FPR": 0.02,
      "threshold_used": 0.19246033430099457,
      "val_threshold": 0.1926410317420958
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_104",
    "model_type": "lstm",
    "equipment": "opcua_multi_19",
    "craft_id": "104",
    "data_size": 23742,
    "best_val_loss": 0.12481909948805008,
    "threshold": 0.26082356125116307,
    "trained_at": "2026-02-12T22:49:56.943944",
    "confusion_matrix": {
      "total_samples": 4739,
      "TP": 237,
      "FP": 35,
      "TN": 4467,
      "FN": 0,
      "accuracy": 99.26,
      "precision": 87.13,
      "recall": 100,
      "f1_score": 93.12,
      "FPR": 0.78,
      "threshold_used": 0.26082356125116307,
      "val_threshold": 0.2822831034660338
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_103",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "103",
    "data_size": 63940,
    "best_val_loss": 0.1260362584874126,
    "threshold": 0.2482362464070316,
    "trained_at": "2026-02-12T21:42:25.951673",
    "confusion_matrix": {
      "total_samples": 12779,
      "TP": 639,
      "FP": 10,
      "TN": 12130,
      "FN": 0,
      "accuracy": 99.92,
      "precision": 98.46,
      "recall": 100,
      "f1_score": 99.22,
      "FPR": 0.08,
      "threshold_used": 0.2482362464070316,
      "val_threshold": 0.25327943861484375
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_33",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "33",
    "data_size": 56324,
    "best_val_loss": 0.12796092100378567,
    "threshold": 0.23215117305517152,
    "trained_at": "2026-02-12T22:07:17.904741",
    "confusion_matrix": {
      "total_samples": 11255,
      "TP": 539,
      "FP": 0,
      "TN": 10692,
      "FN": 24,
      "accuracy": 99.79,
      "precision": 100,
      "recall": 95.74,
      "f1_score": 97.82,
      "FPR": 0,
      "threshold_used": 0.23215117305517152,
      "val_threshold": 0.2212970107793807
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_70",
    "model_type": "lstm",
    "equipment": "opcua_multi_33",
    "craft_id": "70",
    "data_size": 49881,
    "best_val_loss": 0.12936306512557935,
    "threshold": 0.35999891161918274,
    "trained_at": "2026-02-12T22:03:56.117595",
    "confusion_matrix": {
      "total_samples": 9967,
      "TP": 468,
      "FP": 0,
      "TN": 9468,
      "FN": 31,
      "accuracy": 99.69,
      "precision": 100,
      "recall": 93.79,
      "f1_score": 96.8,
      "FPR": 0,
      "threshold_used": 0.35999891161918274,
      "val_threshold": 0.3307701200246783
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_02_MA120IIIE.09",
    "model_type": "lstm",
    "equipment": "opcua_multi_dongtan_02",
    "craft_id": "MA120IIIE.09",
    "data_size": 150445,
    "best_val_loss": 0.13025311128573214,
    "threshold": 0.15187500789761543,
    "trained_at": "2026-02-12T20:10:06.628597",
    "confusion_matrix": {
      "total_samples": 30080,
      "TP": 1504,
      "FP": 29,
      "TN": 28547,
      "FN": 0,
      "accuracy": 99.9,
      "precision": 98.11,
      "recall": 100,
      "f1_score": 99.05,
      "FPR": 0.1,
      "threshold_used": 0.15187500789761543,
      "val_threshold": 0.15262217149138446
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_01_62-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_01",
    "craft_id": "62-1",
    "data_size": 14468,
    "best_val_loss": 0.13145080955903177,
    "threshold": 0.1495839253067968,
    "trained_at": "2026-02-12T21:25:05.110256",
    "confusion_matrix": {
      "total_samples": 2884,
      "TP": 141,
      "FP": 0,
      "TN": 2739,
      "FN": 4,
      "accuracy": 99.86,
      "precision": 100,
      "recall": 97.24,
      "f1_score": 98.6,
      "FPR": 0,
      "threshold_used": 0.1495839253067968,
      "val_threshold": 0.14407742768526077
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_45",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "45",
    "data_size": 45282,
    "best_val_loss": 0.13230538463138264,
    "threshold": 0.0895205233246088,
    "trained_at": "2026-02-12T21:35:27.081422",
    "confusion_matrix": {
      "total_samples": 9047,
      "TP": 453,
      "FP": 19,
      "TN": 8575,
      "FN": 0,
      "accuracy": 99.79,
      "precision": 95.97,
      "recall": 100,
      "f1_score": 97.94,
      "FPR": 0.22,
      "threshold_used": 0.0895205233246088,
      "val_threshold": 0.09055313393473613
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_67-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_33",
    "craft_id": "67-2",
    "data_size": 38628,
    "best_val_loss": 0.13254067324731497,
    "threshold": 0.3169784426689137,
    "trained_at": "2026-02-12T22:15:30.676607",
    "confusion_matrix": {
      "total_samples": 7716,
      "TP": 371,
      "FP": 0,
      "TN": 7330,
      "FN": 15,
      "accuracy": 99.81,
      "precision": 100,
      "recall": 96.11,
      "f1_score": 98.02,
      "FPR": 0,
      "threshold_used": 0.3169784426689137,
      "val_threshold": 0.3048407584428787
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_123",
    "model_type": "lstm",
    "equipment": "opcua_multi_27",
    "craft_id": "123",
    "data_size": 1187,
    "best_val_loss": 0.13449621958690777,
    "threshold": 0.1902051419019699,
    "trained_at": "2026-02-12T22:54:48.173802",
    "confusion_matrix": {
      "total_samples": 228,
      "TP": 8,
      "FP": 0,
      "TN": 216,
      "FN": 4,
      "accuracy": 98.25,
      "precision": 100,
      "recall": 66.67,
      "f1_score": 80,
      "FPR": 0,
      "threshold_used": 0.1902051419019699,
      "val_threshold": 0.18839692845940587
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_124",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "124",
    "data_size": 10144,
    "best_val_loss": 0.1345469080439412,
    "threshold": 0.1431083343923092,
    "trained_at": "2026-02-12T23:12:34.240174",
    "confusion_matrix": {
      "total_samples": 2019,
      "TP": 96,
      "FP": 0,
      "TN": 1918,
      "FN": 5,
      "accuracy": 99.75,
      "precision": 100,
      "recall": 95.05,
      "f1_score": 97.46,
      "FPR": 0,
      "threshold_used": 0.1431083343923092,
      "val_threshold": 0.13363784551620475
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_122",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "122",
    "data_size": 8375,
    "best_val_loss": 0.13531518035254128,
    "threshold": 0.4873568713665,
    "trained_at": "2026-02-12T23:06:26.891801",
    "confusion_matrix": {
      "total_samples": 1666,
      "TP": 84,
      "FP": 6,
      "TN": 1576,
      "FN": 0,
      "accuracy": 99.64,
      "precision": 93.33,
      "recall": 100,
      "f1_score": 96.55,
      "FPR": 0.38,
      "threshold_used": 0.4873568713665,
      "val_threshold": 0.5266991257667542
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_C2-CASE-M",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "C2-CASE-M",
    "data_size": 21885,
    "best_val_loss": 0.13664996670388477,
    "threshold": 0.5376560688018774,
    "trained_at": "2026-02-12T22:54:23.671736",
    "confusion_matrix": {
      "total_samples": 4368,
      "TP": 219,
      "FP": 12,
      "TN": 4137,
      "FN": 0,
      "accuracy": 99.73,
      "precision": 94.81,
      "recall": 100,
      "f1_score": 97.34,
      "FPR": 0.29,
      "threshold_used": 0.5376560688018774,
      "val_threshold": 0.5600601583719241
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_27",
    "model_type": "lstm",
    "equipment": "opcua_multi_20",
    "craft_id": "27",
    "data_size": 9665,
    "best_val_loss": 0.14063724540871048,
    "threshold": 0.5798818528652189,
    "trained_at": "2026-02-12T22:07:58.076384",
    "confusion_matrix": {
      "total_samples": 1924,
      "TP": 97,
      "FP": 4,
      "TN": 1823,
      "FN": 0,
      "accuracy": 99.79,
      "precision": 96.04,
      "recall": 100,
      "f1_score": 97.98,
      "FPR": 0.22,
      "threshold_used": 0.5798818528652189,
      "val_threshold": 0.6072743475437161
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_22",
    "model_type": "lstm",
    "equipment": "opcua_multi_09",
    "craft_id": "22",
    "data_size": 17862,
    "best_val_loss": 0.1407685931724944,
    "threshold": 0.16859815120697003,
    "trained_at": "2026-02-12T22:27:28.232531",
    "confusion_matrix": {
      "total_samples": 3563,
      "TP": 179,
      "FP": 28,
      "TN": 3356,
      "FN": 0,
      "accuracy": 99.21,
      "precision": 86.47,
      "recall": 100,
      "f1_score": 92.74,
      "FPR": 0.83,
      "threshold_used": 0.16859815120697003,
      "val_threshold": 0.22067027390003202
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_36_125-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_36",
    "craft_id": "125-1",
    "data_size": 51566,
    "best_val_loss": 0.14253042454351178,
    "threshold": 0.06026372089982033,
    "trained_at": "2026-02-12T21:25:31.132298",
    "confusion_matrix": {
      "total_samples": 10304,
      "TP": 516,
      "FP": 46,
      "TN": 9742,
      "FN": 0,
      "accuracy": 99.55,
      "precision": 91.81,
      "recall": 100,
      "f1_score": 95.73,
      "FPR": 0.47,
      "threshold_used": 0.06026372089982033,
      "val_threshold": 0.06243223100900658
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_26_60-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_26",
    "craft_id": "60-2",
    "data_size": 12612,
    "best_val_loss": 0.14258121959109066,
    "threshold": 0.27690647393465007,
    "trained_at": "2026-02-12T21:53:34.215813",
    "confusion_matrix": {
      "total_samples": 2513,
      "TP": 126,
      "FP": 2,
      "TN": 2385,
      "FN": 0,
      "accuracy": 99.92,
      "precision": 98.44,
      "recall": 100,
      "f1_score": 99.21,
      "FPR": 0.08,
      "threshold_used": 0.27690647393465007,
      "val_threshold": 0.2861737847328186
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_31_67-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_31",
    "craft_id": "67-1",
    "data_size": 42167,
    "best_val_loss": 0.14293941763094348,
    "threshold": 0.2452179379761219,
    "trained_at": "2026-02-12T21:44:56.984189",
    "confusion_matrix": {
      "total_samples": 8424,
      "TP": 422,
      "FP": 9,
      "TN": 7993,
      "FN": 0,
      "accuracy": 99.89,
      "precision": 97.91,
      "recall": 100,
      "f1_score": 98.94,
      "FPR": 0.11,
      "threshold_used": 0.2452179379761219,
      "val_threshold": 0.2510832399129867
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_17_21",
    "model_type": "lstm",
    "equipment": "opcua_multi_17",
    "craft_id": "21",
    "data_size": 13905,
    "best_val_loss": 0.14423565790164694,
    "threshold": 0.5255913376808174,
    "trained_at": "2026-02-12T23:10:06.748999",
    "confusion_matrix": {
      "total_samples": 2772,
      "TP": 134,
      "FP": 0,
      "TN": 2633,
      "FN": 5,
      "accuracy": 99.82,
      "precision": 100,
      "recall": 96.4,
      "f1_score": 98.17,
      "FPR": 0,
      "threshold_used": 0.5255913376808174,
      "val_threshold": 0.5095508575439442
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_25_60",
    "model_type": "lstm",
    "equipment": "opcua_multi_25",
    "craft_id": "60",
    "data_size": 63319,
    "best_val_loss": 0.1442834009100367,
    "threshold": 0.0961053092032671,
    "trained_at": "2026-02-12T20:26:56.453621",
    "confusion_matrix": {
      "total_samples": 12654,
      "TP": 620,
      "FP": 0,
      "TN": 12021,
      "FN": 13,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 97.95,
      "f1_score": 98.96,
      "FPR": 0,
      "threshold_used": 0.0961053092032671,
      "val_threshold": 0.09235414229333248
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_16_57",
    "model_type": "lstm",
    "equipment": "opcua_multi_16",
    "craft_id": "57",
    "data_size": 15326,
    "best_val_loss": 0.14509287983647193,
    "threshold": 0.44205498695373535,
    "trained_at": "2026-02-12T20:09:13.628759",
    "confusion_matrix": {
      "total_samples": 3056,
      "TP": 145,
      "FP": 0,
      "TN": 2903,
      "FN": 8,
      "accuracy": 99.74,
      "precision": 100,
      "recall": 94.77,
      "f1_score": 97.31,
      "FPR": 0,
      "threshold_used": 0.44205498695373535,
      "val_threshold": 0.31056759506464005
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_96",
    "model_type": "lstm",
    "equipment": "opcua_multi_18",
    "craft_id": "96",
    "data_size": 2842,
    "best_val_loss": 0.14537534893412069,
    "threshold": 0.5024733662605285,
    "trained_at": "2026-02-12T22:41:03.142096",
    "confusion_matrix": {
      "total_samples": 559,
      "TP": 28,
      "FP": 9,
      "TN": 522,
      "FN": 0,
      "accuracy": 98.39,
      "precision": 75.68,
      "recall": 100,
      "f1_score": 86.16,
      "FPR": 1.69,
      "threshold_used": 0.5024733662605285,
      "val_threshold": 1.0146773695945752
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_100",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "100",
    "data_size": 2390,
    "best_val_loss": 0.14574303279426307,
    "threshold": 0.8582167774438857,
    "trained_at": "2026-02-12T22:06:33.938006",
    "confusion_matrix": {
      "total_samples": 469,
      "TP": 24,
      "FP": 1,
      "TN": 444,
      "FN": 0,
      "accuracy": 99.79,
      "precision": 96,
      "recall": 100,
      "f1_score": 97.96,
      "FPR": 0.22,
      "threshold_used": 0.8582167774438857,
      "val_threshold": 0.8629334568977354
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_23_12",
    "model_type": "lstm",
    "equipment": "opcua_multi_23",
    "craft_id": "12",
    "data_size": 23044,
    "best_val_loss": 0.1478655910924171,
    "threshold": 0.22147589549422264,
    "trained_at": "2026-02-12T20:51:36.745737",
    "confusion_matrix": {
      "total_samples": 4599,
      "TP": 230,
      "FP": 4,
      "TN": 4365,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.29,
      "recall": 100,
      "f1_score": 99.14,
      "FPR": 0.09,
      "threshold_used": 0.22147589549422264,
      "val_threshold": 0.22205839157104482
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_30",
    "model_type": "lstm",
    "equipment": "opcua_multi_06",
    "craft_id": "30",
    "data_size": 17336,
    "best_val_loss": 0.14805658901958124,
    "threshold": 0.475857216119766,
    "trained_at": "2026-02-12T22:45:26.900417",
    "confusion_matrix": {
      "total_samples": 3458,
      "TP": 170,
      "FP": 0,
      "TN": 3285,
      "FN": 3,
      "accuracy": 99.91,
      "precision": 100,
      "recall": 98.27,
      "f1_score": 99.13,
      "FPR": 0,
      "threshold_used": 0.475857216119766,
      "val_threshold": 0.4568208128213875
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_64-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_02",
    "craft_id": "64-2",
    "data_size": 72959,
    "best_val_loss": 0.14830516276086836,
    "threshold": 0.10376292280852789,
    "trained_at": "2026-02-12T21:38:50.247466",
    "confusion_matrix": {
      "total_samples": 14582,
      "TP": 730,
      "FP": 29,
      "TN": 13823,
      "FN": 0,
      "accuracy": 99.8,
      "precision": 96.18,
      "recall": 100,
      "f1_score": 98.05,
      "FPR": 0.21,
      "threshold_used": 0.10376292280852789,
      "val_threshold": 0.10460111349821083
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_92",
    "model_type": "lstm",
    "equipment": "opcua_multi_34",
    "craft_id": "92",
    "data_size": 13504,
    "best_val_loss": 0.14890032896473698,
    "threshold": 0.5082784295082092,
    "trained_at": "2026-02-12T23:12:08.225537",
    "confusion_matrix": {
      "total_samples": 2691,
      "TP": 135,
      "FP": 3,
      "TN": 2553,
      "FN": 0,
      "accuracy": 99.89,
      "precision": 97.83,
      "recall": 100,
      "f1_score": 98.9,
      "FPR": 0.12,
      "threshold_used": 0.5082784295082092,
      "val_threshold": 0.509071558713913
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_MAHIND-GEA3",
    "model_type": "lstm",
    "equipment": "opcua_multi_27",
    "craft_id": "MAHIND-GEA3",
    "data_size": 24463,
    "best_val_loss": 0.14924349937799303,
    "threshold": 0.11609034985303879,
    "trained_at": "2026-02-12T21:38:30.163913",
    "confusion_matrix": {
      "total_samples": 4883,
      "TP": 245,
      "FP": 37,
      "TN": 4601,
      "FN": 0,
      "accuracy": 99.24,
      "precision": 86.88,
      "recall": 100,
      "f1_score": 92.98,
      "FPR": 0.8,
      "threshold_used": 0.11609034985303879,
      "val_threshold": 0.1293444618582725
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_13_26",
    "model_type": "lstm",
    "equipment": "opcua_multi_13",
    "craft_id": "26",
    "data_size": 75219,
    "best_val_loss": 0.14926740245265943,
    "threshold": 0.2503570318222046,
    "trained_at": "2026-02-12T21:29:54.356599",
    "confusion_matrix": {
      "total_samples": 15034,
      "TP": 752,
      "FP": 5,
      "TN": 14277,
      "FN": 0,
      "accuracy": 99.97,
      "precision": 99.34,
      "recall": 100,
      "f1_score": 99.67,
      "FPR": 0.04,
      "threshold_used": 0.2503570318222046,
      "val_threshold": 0.2522392407059664
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_17_58",
    "model_type": "lstm",
    "equipment": "opcua_multi_17",
    "craft_id": "58",
    "data_size": 117561,
    "best_val_loss": 0.15003730833849968,
    "threshold": 0.3680453002452849,
    "trained_at": "2026-02-12T20:07:19.155247",
    "confusion_matrix": {
      "total_samples": 23503,
      "TP": 1176,
      "FP": 25,
      "TN": 22302,
      "FN": 0,
      "accuracy": 99.89,
      "precision": 97.92,
      "recall": 100,
      "f1_score": 98.95,
      "FPR": 0.11,
      "threshold_used": 0.3680453002452849,
      "val_threshold": 0.3737570732831952
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_38",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "38",
    "data_size": 4012,
    "best_val_loss": 0.15061453260096144,
    "threshold": 0.28470033556222885,
    "trained_at": "2026-02-12T23:01:57.964871",
    "confusion_matrix": {
      "total_samples": 793,
      "TP": 34,
      "FP": 0,
      "TN": 753,
      "FN": 6,
      "accuracy": 99.24,
      "precision": 100,
      "recall": 85,
      "f1_score": 91.89,
      "FPR": 0,
      "threshold_used": 0.28470033556222885,
      "val_threshold": 0.21873342096805568
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_30_70",
    "model_type": "lstm",
    "equipment": "opcua_multi_30",
    "craft_id": "70",
    "data_size": 30842,
    "best_val_loss": 0.15211333128251528,
    "threshold": 0.1720233418047418,
    "trained_at": "2026-02-12T21:45:47.184448",
    "confusion_matrix": {
      "total_samples": 6159,
      "TP": 307,
      "FP": 0,
      "TN": 5851,
      "FN": 1,
      "accuracy": 99.98,
      "precision": 100,
      "recall": 99.68,
      "f1_score": 99.84,
      "FPR": 0,
      "threshold_used": 0.1720233418047418,
      "val_threshold": 0.1668619826436024
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_67-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_32",
    "craft_id": "67-2",
    "data_size": 7681,
    "best_val_loss": 0.15261034241047416,
    "threshold": 0.5116652846336366,
    "trained_at": "2026-02-12T21:30:32.999337",
    "confusion_matrix": {
      "total_samples": 1527,
      "TP": 67,
      "FP": 0,
      "TN": 1450,
      "FN": 10,
      "accuracy": 99.35,
      "precision": 100,
      "recall": 87.01,
      "f1_score": 93.05,
      "FPR": 0,
      "threshold_used": 0.5116652846336366,
      "val_threshold": 0.45877273082733194
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_31_67",
    "model_type": "lstm",
    "equipment": "opcua_multi_31",
    "craft_id": "67",
    "data_size": 1150,
    "best_val_loss": 0.15379414312979756,
    "threshold": 0.29010077863931655,
    "trained_at": "2026-02-12T23:17:08.635952",
    "confusion_matrix": {
      "total_samples": 221,
      "TP": 11,
      "FP": 4,
      "TN": 206,
      "FN": 0,
      "accuracy": 98.19,
      "precision": 73.33,
      "recall": 100,
      "f1_score": 84.61,
      "FPR": 1.9,
      "threshold_used": 0.29010077863931655,
      "val_threshold": 0.2960963845252991
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_105",
    "model_type": "lstm",
    "equipment": "opcua_multi_09",
    "craft_id": "105",
    "data_size": 5617,
    "best_val_loss": 0.15416657697255565,
    "threshold": 0.36049058586356253,
    "trained_at": "2026-02-12T23:20:36.231169",
    "confusion_matrix": {
      "total_samples": 1114,
      "TP": 52,
      "FP": 0,
      "TN": 1058,
      "FN": 4,
      "accuracy": 99.64,
      "precision": 100,
      "recall": 92.86,
      "f1_score": 96.3,
      "FPR": 0,
      "threshold_used": 0.36049058586356253,
      "val_threshold": 0.22934810221195187
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_30",
    "model_type": "lstm",
    "equipment": "opcua_multi_10",
    "craft_id": "30",
    "data_size": 17825,
    "best_val_loss": 0.15425999981379482,
    "threshold": 0.1592335171997547,
    "trained_at": "2026-02-12T22:51:51.108489",
    "confusion_matrix": {
      "total_samples": 3556,
      "TP": 178,
      "FP": 1,
      "TN": 3377,
      "FN": 0,
      "accuracy": 99.97,
      "precision": 99.44,
      "recall": 100,
      "f1_score": 99.72,
      "FPR": 0.03,
      "threshold_used": 0.1592335171997547,
      "val_threshold": 0.15932993963360786
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_04_MA120IIIE.09",
    "model_type": "lstm",
    "equipment": "opcua_multi_dongtan_04",
    "craft_id": "MA120IIIE.09",
    "data_size": 336221,
    "best_val_loss": 0.15464202385370002,
    "threshold": 0.11934603154659203,
    "trained_at": "2026-02-12T19:54:22.696004",
    "confusion_matrix": {
      "total_samples": 67235,
      "TP": 3362,
      "FP": 2,
      "TN": 63871,
      "FN": 0,
      "accuracy": 100,
      "precision": 99.94,
      "recall": 100,
      "f1_score": 99.97,
      "FPR": 0,
      "threshold_used": 0.11934603154659203,
      "val_threshold": 0.11937085837125778
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_17_27",
    "model_type": "lstm",
    "equipment": "opcua_multi_17",
    "craft_id": "27",
    "data_size": 19133,
    "best_val_loss": 0.1547514002673564,
    "threshold": 0.2050298497080802,
    "trained_at": "2026-02-12T22:59:38.274499",
    "confusion_matrix": {
      "total_samples": 3817,
      "TP": 188,
      "FP": 0,
      "TN": 3626,
      "FN": 3,
      "accuracy": 99.92,
      "precision": 100,
      "recall": 98.43,
      "f1_score": 99.21,
      "FPR": 0,
      "threshold_used": 0.2050298497080802,
      "val_threshold": 0.20360676050186147
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_37_115",
    "model_type": "lstm",
    "equipment": "opcua_multi_37",
    "craft_id": "115",
    "data_size": 49918,
    "best_val_loss": 0.15665267004663394,
    "threshold": 0.29913759529590583,
    "trained_at": "2026-02-12T20:16:21.614041",
    "confusion_matrix": {
      "total_samples": 9974,
      "TP": 479,
      "FP": 0,
      "TN": 9475,
      "FN": 20,
      "accuracy": 99.8,
      "precision": 100,
      "recall": 95.99,
      "f1_score": 97.95,
      "FPR": 0,
      "threshold_used": 0.29913759529590583,
      "val_threshold": 0.2890638917684556
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_82",
    "model_type": "lstm",
    "equipment": "opcua_multi_40",
    "craft_id": "82",
    "data_size": 21198,
    "best_val_loss": 0.15777665780368427,
    "threshold": 0.10234845131635664,
    "trained_at": "2026-02-12T22:56:00.198436",
    "confusion_matrix": {
      "total_samples": 4230,
      "TP": 209,
      "FP": 0,
      "TN": 4018,
      "FN": 3,
      "accuracy": 99.93,
      "precision": 100,
      "recall": 98.58,
      "f1_score": 99.28,
      "FPR": 0,
      "threshold_used": 0.10234845131635664,
      "val_threshold": 0.10192853026092046
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_73",
    "model_type": "lstm",
    "equipment": "opcua_multi_33",
    "craft_id": "73",
    "data_size": 4919,
    "best_val_loss": 0.15799683011165636,
    "threshold": 0.23271365463733673,
    "trained_at": "2026-02-12T23:00:19.856410",
    "confusion_matrix": {
      "total_samples": 974,
      "TP": 49,
      "FP": 6,
      "TN": 919,
      "FN": 0,
      "accuracy": 99.38,
      "precision": 89.09,
      "recall": 100,
      "f1_score": 94.23,
      "FPR": 0.65,
      "threshold_used": 0.23271365463733673,
      "val_threshold": 0.38009643405672267
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_100",
    "model_type": "lstm",
    "equipment": "opcua_multi_19",
    "craft_id": "100",
    "data_size": 10337,
    "best_val_loss": 0.15956482281084775,
    "threshold": 0.19051076844334586,
    "trained_at": "2026-02-12T23:06:48.402921",
    "confusion_matrix": {
      "total_samples": 2058,
      "TP": 103,
      "FP": 16,
      "TN": 1939,
      "FN": 0,
      "accuracy": 99.22,
      "precision": 86.55,
      "recall": 100,
      "f1_score": 92.79,
      "FPR": 0.82,
      "threshold_used": 0.19051076844334586,
      "val_threshold": 0.2108500778675079
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_73",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "73",
    "data_size": 6365,
    "best_val_loss": 0.15984214370763755,
    "threshold": 0.31180450618267047,
    "trained_at": "2026-02-12T23:18:41.825054",
    "confusion_matrix": {
      "total_samples": 1264,
      "TP": 64,
      "FP": 2,
      "TN": 1198,
      "FN": 0,
      "accuracy": 99.84,
      "precision": 96.97,
      "recall": 100,
      "f1_score": 98.46,
      "FPR": 0.17,
      "threshold_used": 0.31180450618267047,
      "val_threshold": 0.31956150531768757
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_30_69",
    "model_type": "lstm",
    "equipment": "opcua_multi_30",
    "craft_id": "69",
    "data_size": 77867,
    "best_val_loss": 0.15992258842608456,
    "threshold": 0.38977143466472625,
    "trained_at": "2026-02-12T21:11:18.625625",
    "confusion_matrix": {
      "total_samples": 15564,
      "TP": 735,
      "FP": 0,
      "TN": 14785,
      "FN": 44,
      "accuracy": 99.72,
      "precision": 100,
      "recall": 94.35,
      "f1_score": 97.09,
      "FPR": 0,
      "threshold_used": 0.38977143466472625,
      "val_threshold": 0.37832430005073536
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_90",
    "model_type": "lstm",
    "equipment": "opcua_multi_20",
    "craft_id": "90",
    "data_size": 2891,
    "best_val_loss": 0.1604464795499359,
    "threshold": 1.1579645633697515,
    "trained_at": "2026-02-12T23:15:47.495754",
    "confusion_matrix": {
      "total_samples": 569,
      "TP": 25,
      "FP": 0,
      "TN": 540,
      "FN": 4,
      "accuracy": 99.3,
      "precision": 100,
      "recall": 86.21,
      "f1_score": 92.59,
      "FPR": 0,
      "threshold_used": 1.1579645633697515,
      "val_threshold": 0.808741044998173
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_61-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_27",
    "craft_id": "61-2",
    "data_size": 52304,
    "best_val_loss": 0.1609480632838878,
    "threshold": 0.1751666106283664,
    "trained_at": "2026-02-12T21:52:16.571118",
    "confusion_matrix": {
      "total_samples": 10451,
      "TP": 501,
      "FP": 0,
      "TN": 9928,
      "FN": 22,
      "accuracy": 99.79,
      "precision": 100,
      "recall": 95.79,
      "f1_score": 97.85,
      "FPR": 0,
      "threshold_used": 0.1751666106283664,
      "val_threshold": 0.1623368263244629
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_72",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "72",
    "data_size": 49630,
    "best_val_loss": 0.1613871351258582,
    "threshold": 0.15697196274995767,
    "trained_at": "2026-02-12T22:17:05.293190",
    "confusion_matrix": {
      "total_samples": 9917,
      "TP": 494,
      "FP": 0,
      "TN": 9421,
      "FN": 2,
      "accuracy": 99.98,
      "precision": 100,
      "recall": 99.6,
      "f1_score": 99.8,
      "FPR": 0,
      "threshold_used": 0.15697196274995767,
      "val_threshold": 0.154465141892432
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_36_29",
    "model_type": "lstm",
    "equipment": "opcua_multi_36",
    "craft_id": "29",
    "data_size": 2376,
    "best_val_loss": 0.16158647924789543,
    "threshold": 0.3711569309234619,
    "trained_at": "2026-02-12T23:07:06.325827",
    "confusion_matrix": {
      "total_samples": 466,
      "TP": 24,
      "FP": 3,
      "TN": 439,
      "FN": 0,
      "accuracy": 99.36,
      "precision": 88.89,
      "recall": 100,
      "f1_score": 94.12,
      "FPR": 0.68,
      "threshold_used": 0.3711569309234619,
      "val_threshold": 0.42505791038274765
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_40-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "40-2",
    "data_size": 35260,
    "best_val_loss": 0.16338212553786738,
    "threshold": 0.10881825685501094,
    "trained_at": "2026-02-12T22:22:58.732318",
    "confusion_matrix": {
      "total_samples": 7043,
      "TP": 353,
      "FP": 12,
      "TN": 6678,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.71,
      "recall": 100,
      "f1_score": 98.33,
      "FPR": 0.18,
      "threshold_used": 0.10881825685501094,
      "val_threshold": 0.10996368303894993
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_24_108",
    "model_type": "lstm",
    "equipment": "opcua_multi_24",
    "craft_id": "108",
    "data_size": 3975,
    "best_val_loss": 0.16429190193575455,
    "threshold": 0.7791881501674642,
    "trained_at": "2026-02-12T22:11:41.954230",
    "confusion_matrix": {
      "total_samples": 786,
      "TP": 29,
      "FP": 0,
      "TN": 746,
      "FN": 11,
      "accuracy": 98.6,
      "precision": 100,
      "recall": 72.5,
      "f1_score": 84.06,
      "FPR": 0,
      "threshold_used": 0.7791881501674642,
      "val_threshold": 0.5484833717346191
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_29",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "29",
    "data_size": 15378,
    "best_val_loss": 0.16498238855543979,
    "threshold": 0.19312765449285504,
    "trained_at": "2026-02-12T22:56:59.201293",
    "confusion_matrix": {
      "total_samples": 3066,
      "TP": 154,
      "FP": 9,
      "TN": 2903,
      "FN": 0,
      "accuracy": 99.71,
      "precision": 94.48,
      "recall": 100,
      "f1_score": 97.16,
      "FPR": 0.31,
      "threshold_used": 0.19312765449285504,
      "val_threshold": 0.19833173230290413
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_69",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "69",
    "data_size": 19535,
    "best_val_loss": 0.1653651617058367,
    "threshold": 0.2662953853607176,
    "trained_at": "2026-02-12T22:57:56.261875",
    "confusion_matrix": {
      "total_samples": 3898,
      "TP": 195,
      "FP": 4,
      "TN": 3699,
      "FN": 0,
      "accuracy": 99.9,
      "precision": 97.99,
      "recall": 100,
      "f1_score": 98.98,
      "FPR": 0.11,
      "threshold_used": 0.2662953853607176,
      "val_threshold": 0.26665481477975844
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_01_DN8-GEAR3",
    "model_type": "lstm",
    "equipment": "opcua_multi_01",
    "craft_id": "DN8-GEAR3",
    "data_size": 76521,
    "best_val_loss": 0.16651896491559084,
    "threshold": 0.09440866261720623,
    "trained_at": "2026-02-12T20:22:04.826748",
    "confusion_matrix": {
      "total_samples": 15295,
      "TP": 758,
      "FP": 0,
      "TN": 14530,
      "FN": 7,
      "accuracy": 99.95,
      "precision": 100,
      "recall": 99.08,
      "f1_score": 99.54,
      "FPR": 0,
      "threshold_used": 0.09440866261720623,
      "val_threshold": 0.0935340747237204
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_110",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "110",
    "data_size": 10959,
    "best_val_loss": 0.1667663720389444,
    "threshold": 0.25792179703712353,
    "trained_at": "2026-02-12T23:10:44.573946",
    "confusion_matrix": {
      "total_samples": 2182,
      "TP": 102,
      "FP": 0,
      "TN": 2072,
      "FN": 8,
      "accuracy": 99.63,
      "precision": 100,
      "recall": 92.73,
      "f1_score": 96.23,
      "FPR": 0,
      "threshold_used": 0.25792179703712353,
      "val_threshold": 0.23526537939906034
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_68",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "68",
    "data_size": 4914,
    "best_val_loss": 0.1667912511072693,
    "threshold": 0.3125747710466385,
    "trained_at": "2026-02-12T23:00:41.678357",
    "confusion_matrix": {
      "total_samples": 973,
      "TP": 49,
      "FP": 4,
      "TN": 920,
      "FN": 0,
      "accuracy": 99.59,
      "precision": 92.45,
      "recall": 100,
      "f1_score": 96.08,
      "FPR": 0.43,
      "threshold_used": 0.3125747710466385,
      "val_threshold": 0.318978601694107
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_36",
    "model_type": "lstm",
    "equipment": "opcua_multi_08",
    "craft_id": "36",
    "data_size": 47470,
    "best_val_loss": 0.16738999512048539,
    "threshold": 0.12597165629267693,
    "trained_at": "2026-02-12T22:30:11.207451",
    "confusion_matrix": {
      "total_samples": 9485,
      "TP": 475,
      "FP": 12,
      "TN": 8998,
      "FN": 0,
      "accuracy": 99.87,
      "precision": 97.54,
      "recall": 100,
      "f1_score": 98.75,
      "FPR": 0.13,
      "threshold_used": 0.12597165629267693,
      "val_threshold": 0.13303525149822157
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_93",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "93",
    "data_size": 17183,
    "best_val_loss": 0.16890595910833187,
    "threshold": 0.34886374473571774,
    "trained_at": "2026-02-12T23:03:42.144107",
    "confusion_matrix": {
      "total_samples": 3427,
      "TP": 162,
      "FP": 0,
      "TN": 3255,
      "FN": 10,
      "accuracy": 99.71,
      "precision": 100,
      "recall": 94.19,
      "f1_score": 97.01,
      "FPR": 0,
      "threshold_used": 0.34886374473571774,
      "val_threshold": 0.34539617896080016
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_121",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "121",
    "data_size": 16297,
    "best_val_loss": 0.1689995574584374,
    "threshold": 0.09716449491679606,
    "trained_at": "2026-02-12T22:59:36.631644",
    "confusion_matrix": {
      "total_samples": 3250,
      "TP": 136,
      "FP": 0,
      "TN": 3087,
      "FN": 27,
      "accuracy": 99.17,
      "precision": 100,
      "recall": 83.44,
      "f1_score": 90.97,
      "FPR": 0,
      "threshold_used": 0.09716449491679606,
      "val_threshold": 0.07281881719827615
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_QV-SIDE-BAR",
    "model_type": "lstm",
    "equipment": "opcua_multi_20",
    "craft_id": "QV-SIDE-BAR",
    "data_size": 1279,
    "best_val_loss": 0.1690207914850576,
    "threshold": 0.34761257767677256,
    "trained_at": "2026-02-12T23:19:05.286022",
    "confusion_matrix": {
      "total_samples": 246,
      "TP": 13,
      "FP": 0,
      "TN": 233,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.34761257767677256,
      "val_threshold": 0.5300051793456078
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_72",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "72",
    "data_size": 16490,
    "best_val_loss": 0.17223434613246835,
    "threshold": 0.1895634986460209,
    "trained_at": "2026-02-12T23:05:21.357775",
    "confusion_matrix": {
      "total_samples": 3289,
      "TP": 165,
      "FP": 16,
      "TN": 3108,
      "FN": 0,
      "accuracy": 99.51,
      "precision": 91.16,
      "recall": 100,
      "f1_score": 95.38,
      "FPR": 0.51,
      "threshold_used": 0.1895634986460209,
      "val_threshold": 0.19032082557678223
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_113",
    "model_type": "lstm",
    "equipment": "opcua_multi_32",
    "craft_id": "113",
    "data_size": 2985,
    "best_val_loss": 0.1734623489331226,
    "threshold": 0.895275840163231,
    "trained_at": "2026-02-12T22:53:53.893140",
    "confusion_matrix": {
      "total_samples": 588,
      "TP": 30,
      "FP": 4,
      "TN": 554,
      "FN": 0,
      "accuracy": 99.32,
      "precision": 88.24,
      "recall": 100,
      "f1_score": 93.75,
      "FPR": 0.72,
      "threshold_used": 0.895275840163231,
      "val_threshold": 0.921107906103134
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_12_32",
    "model_type": "lstm",
    "equipment": "opcua_multi_12",
    "craft_id": "32",
    "data_size": 17022,
    "best_val_loss": 0.17422550588143942,
    "threshold": 0.1589056707918644,
    "trained_at": "2026-02-12T22:52:11.282356",
    "confusion_matrix": {
      "total_samples": 3395,
      "TP": 170,
      "FP": 9,
      "TN": 3216,
      "FN": 0,
      "accuracy": 99.73,
      "precision": 94.97,
      "recall": 100,
      "f1_score": 97.42,
      "FPR": 0.28,
      "threshold_used": 0.1589056707918644,
      "val_threshold": 0.1644618824124336
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_12_35-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_12",
    "craft_id": "35-1",
    "data_size": 45715,
    "best_val_loss": 0.18159395034027512,
    "threshold": 0.21636428534984553,
    "trained_at": "2026-02-12T20:51:21.024398",
    "confusion_matrix": {
      "total_samples": 9134,
      "TP": 404,
      "FP": 0,
      "TN": 8677,
      "FN": 53,
      "accuracy": 99.42,
      "precision": 100,
      "recall": 88.4,
      "f1_score": 93.84,
      "FPR": 0,
      "threshold_used": 0.21636428534984553,
      "val_threshold": 0.18622579425573377
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_85",
    "model_type": "lstm",
    "equipment": "opcua_multi_40",
    "craft_id": "85",
    "data_size": 6284,
    "best_val_loss": 0.18387235880328257,
    "threshold": 0.4600185379385939,
    "trained_at": "2026-02-12T23:18:51.650394",
    "confusion_matrix": {
      "total_samples": 1247,
      "TP": 47,
      "FP": 0,
      "TN": 1184,
      "FN": 16,
      "accuracy": 98.72,
      "precision": 100,
      "recall": 74.6,
      "f1_score": 85.45,
      "FPR": 0,
      "threshold_used": 0.4600185379385939,
      "val_threshold": 0.3411230236291887
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_104",
    "model_type": "lstm",
    "equipment": "opcua_multi_11",
    "craft_id": "104",
    "data_size": 5989,
    "best_val_loss": 0.1839958714064123,
    "threshold": 0.5117278367280956,
    "trained_at": "2026-02-12T23:19:51.956000",
    "confusion_matrix": {
      "total_samples": 1188,
      "TP": 60,
      "FP": 0,
      "TN": 1128,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.5117278367280956,
      "val_threshold": 0.5073102861642816
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_23_72",
    "model_type": "lstm",
    "equipment": "opcua_multi_23",
    "craft_id": "72",
    "data_size": 9731,
    "best_val_loss": 0.18526785178749478,
    "threshold": 0.39003304243087594,
    "trained_at": "2026-02-12T23:15:37.453540",
    "confusion_matrix": {
      "total_samples": 1937,
      "TP": 97,
      "FP": 1,
      "TN": 1839,
      "FN": 0,
      "accuracy": 99.95,
      "precision": 98.98,
      "recall": 100,
      "f1_score": 99.49,
      "FPR": 0.05,
      "threshold_used": 0.39003304243087594,
      "val_threshold": 0.3905522584915161
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_28",
    "model_type": "lstm",
    "equipment": "opcua_multi_20",
    "craft_id": "28",
    "data_size": 8056,
    "best_val_loss": 0.18746069781528726,
    "threshold": 0.6942842006683348,
    "trained_at": "2026-02-12T23:01:26.339615",
    "confusion_matrix": {
      "total_samples": 1602,
      "TP": 81,
      "FP": 4,
      "TN": 1517,
      "FN": 0,
      "accuracy": 99.75,
      "precision": 95.29,
      "recall": 100,
      "f1_score": 97.59,
      "FPR": 0.26,
      "threshold_used": 0.6942842006683348,
      "val_threshold": 0.6956012070178985
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_QV-STONE",
    "model_type": "lstm",
    "equipment": "opcua_multi_18",
    "craft_id": "QV-STONE",
    "data_size": 1983,
    "best_val_loss": 0.18751444650250812,
    "threshold": 0.7632423162460298,
    "trained_at": "2026-02-12T22:49:11.661792",
    "confusion_matrix": {
      "total_samples": 387,
      "TP": 20,
      "FP": 0,
      "TN": 367,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.7632423162460298,
      "val_threshold": 0.7760774850845334
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_28_61-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_28",
    "craft_id": "61-1",
    "data_size": 15484,
    "best_val_loss": 0.18866817968386757,
    "threshold": 0.5845005154609679,
    "trained_at": "2026-02-12T22:25:39.470531",
    "confusion_matrix": {
      "total_samples": 3087,
      "TP": 155,
      "FP": 16,
      "TN": 2916,
      "FN": 0,
      "accuracy": 99.48,
      "precision": 90.64,
      "recall": 100,
      "f1_score": 95.09,
      "FPR": 0.55,
      "threshold_used": 0.5845005154609679,
      "val_threshold": 0.6117343842983236
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_93",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "93",
    "data_size": 8724,
    "best_val_loss": 0.18935018081314625,
    "threshold": 0.1717656411230563,
    "trained_at": "2026-02-12T23:16:54.331977",
    "confusion_matrix": {
      "total_samples": 1735,
      "TP": 84,
      "FP": 0,
      "TN": 1648,
      "FN": 3,
      "accuracy": 99.83,
      "precision": 100,
      "recall": 96.55,
      "f1_score": 98.24,
      "FPR": 0,
      "threshold_used": 0.1717656411230563,
      "val_threshold": 0.1703482314944267
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_35_63-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_35",
    "craft_id": "63-1",
    "data_size": 50141,
    "best_val_loss": 0.19004716156421456,
    "threshold": 0.23265666961669945,
    "trained_at": "2026-02-12T22:11:09.892353",
    "confusion_matrix": {
      "total_samples": 10019,
      "TP": 501,
      "FP": 30,
      "TN": 9488,
      "FN": 0,
      "accuracy": 99.7,
      "precision": 94.35,
      "recall": 100,
      "f1_score": 97.09,
      "FPR": 0.32,
      "threshold_used": 0.23265666961669945,
      "val_threshold": 0.243519648909569
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_23_XMA-3",
    "model_type": "lstm",
    "equipment": "opcua_multi_23",
    "craft_id": "XMA-3",
    "data_size": 64757,
    "best_val_loss": 0.19106001550369994,
    "threshold": 0.08745406940579414,
    "trained_at": "2026-02-12T21:48:57.918939",
    "confusion_matrix": {
      "total_samples": 12942,
      "TP": 648,
      "FP": 11,
      "TN": 12283,
      "FN": 0,
      "accuracy": 99.92,
      "precision": 98.33,
      "recall": 100,
      "f1_score": 99.16,
      "FPR": 0.09,
      "threshold_used": 0.08745406940579414,
      "val_threshold": 0.08932125233113744
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_131",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "131",
    "data_size": 10895,
    "best_val_loss": 0.191237866813274,
    "threshold": 0.17249782755970955,
    "trained_at": "2026-02-12T23:14:25.565308",
    "confusion_matrix": {
      "total_samples": 2170,
      "TP": 109,
      "FP": 2,
      "TN": 2059,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.2,
      "recall": 100,
      "f1_score": 99.09,
      "FPR": 0.1,
      "threshold_used": 0.17249782755970955,
      "val_threshold": 0.1745757944881916
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_31",
    "model_type": "lstm",
    "equipment": "opcua_multi_09",
    "craft_id": "31",
    "data_size": 35367,
    "best_val_loss": 0.19281479314661512,
    "threshold": 0.12976957857608784,
    "trained_at": "2026-02-12T22:11:32.527832",
    "confusion_matrix": {
      "total_samples": 7064,
      "TP": 343,
      "FP": 0,
      "TN": 6710,
      "FN": 11,
      "accuracy": 99.84,
      "precision": 100,
      "recall": 96.89,
      "f1_score": 98.42,
      "FPR": 0,
      "threshold_used": 0.12976957857608784,
      "val_threshold": 0.12782731130719183
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_36-1",
    "model_type": "lstm",
    "equipment": "opcua_multi_20",
    "craft_id": "36-1",
    "data_size": 2637,
    "best_val_loss": 0.19368080760291184,
    "threshold": 0.32798544764518733,
    "trained_at": "2026-02-12T23:20:17.980210",
    "confusion_matrix": {
      "total_samples": 518,
      "TP": 18,
      "FP": 0,
      "TN": 492,
      "FN": 8,
      "accuracy": 98.46,
      "precision": 100,
      "recall": 69.23,
      "f1_score": 81.82,
      "FPR": 0,
      "threshold_used": 0.32798544764518733,
      "val_threshold": 0.2655343979597091
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_21",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "21",
    "data_size": 29686,
    "best_val_loss": 0.19719546347574987,
    "threshold": 0.34810698032379134,
    "trained_at": "2026-02-12T22:45:58.698743",
    "confusion_matrix": {
      "total_samples": 5928,
      "TP": 297,
      "FP": 13,
      "TN": 5618,
      "FN": 0,
      "accuracy": 99.78,
      "precision": 95.81,
      "recall": 100,
      "f1_score": 97.86,
      "FPR": 0.23,
      "threshold_used": 0.34810698032379134,
      "val_threshold": 0.3602929487824439
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_99",
    "model_type": "lstm",
    "equipment": "opcua_multi_10",
    "craft_id": "99",
    "data_size": 45832,
    "best_val_loss": 0.2007919330582343,
    "threshold": 0.16573895514011383,
    "trained_at": "2026-02-12T22:32:11.627953",
    "confusion_matrix": {
      "total_samples": 9157,
      "TP": 458,
      "FP": 4,
      "TN": 8695,
      "FN": 0,
      "accuracy": 99.96,
      "precision": 99.13,
      "recall": 100,
      "f1_score": 99.56,
      "FPR": 0.05,
      "threshold_used": 0.16573895514011383,
      "val_threshold": 0.16645346283912646
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_96",
    "model_type": "lstm",
    "equipment": "opcua_multi_27",
    "craft_id": "96",
    "data_size": 2396,
    "best_val_loss": 0.20138764172158344,
    "threshold": 0.5287314772605889,
    "trained_at": "2026-02-12T23:07:25.077480",
    "confusion_matrix": {
      "total_samples": 470,
      "TP": 24,
      "FP": 1,
      "TN": 445,
      "FN": 0,
      "accuracy": 99.79,
      "precision": 96,
      "recall": 100,
      "f1_score": 97.96,
      "FPR": 0.22,
      "threshold_used": 0.5287314772605889,
      "val_threshold": 0.5869994670152623
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_105",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "105",
    "data_size": 5190,
    "best_val_loss": 0.20165113454541614,
    "threshold": 0.7261650919914243,
    "trained_at": "2026-02-12T23:21:16.570693",
    "confusion_matrix": {
      "total_samples": 1029,
      "TP": 52,
      "FP": 4,
      "TN": 973,
      "FN": 0,
      "accuracy": 99.61,
      "precision": 92.86,
      "recall": 100,
      "f1_score": 96.3,
      "FPR": 0.41,
      "threshold_used": 0.7261650919914243,
      "val_threshold": 0.7743507266044611
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_102",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "102",
    "data_size": 8960,
    "best_val_loss": 0.20276498451904174,
    "threshold": 0.7626602292060849,
    "trained_at": "2026-02-12T23:05:46.924526",
    "confusion_matrix": {
      "total_samples": 1783,
      "TP": 90,
      "FP": 23,
      "TN": 1670,
      "FN": 0,
      "accuracy": 98.71,
      "precision": 79.65,
      "recall": 100,
      "f1_score": 88.67,
      "FPR": 1.36,
      "threshold_used": 0.7626602292060849,
      "val_threshold": 0.9717779636383047
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_96",
    "model_type": "lstm",
    "equipment": "opcua_multi_32",
    "craft_id": "96",
    "data_size": 3002,
    "best_val_loss": 0.20500935926756075,
    "threshold": 0.8078954964876174,
    "trained_at": "2026-02-12T22:23:23.048059",
    "confusion_matrix": {
      "total_samples": 591,
      "TP": 30,
      "FP": 4,
      "TN": 557,
      "FN": 0,
      "accuracy": 99.32,
      "precision": 88.24,
      "recall": 100,
      "f1_score": 93.75,
      "FPR": 0.71,
      "threshold_used": 0.8078954964876174,
      "val_threshold": 0.8882954120635986
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_22_62-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_22",
    "craft_id": "62-2",
    "data_size": 7584,
    "best_val_loss": 0.2117394460952274,
    "threshold": 0.4519226029515244,
    "trained_at": "2026-02-12T21:54:42.763042",
    "confusion_matrix": {
      "total_samples": 1507,
      "TP": 76,
      "FP": 3,
      "TN": 1428,
      "FN": 0,
      "accuracy": 99.8,
      "precision": 96.2,
      "recall": 100,
      "f1_score": 98.06,
      "FPR": 0.21,
      "threshold_used": 0.4519226029515244,
      "val_threshold": 0.4837857663631441
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_73",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "73",
    "data_size": 20981,
    "best_val_loss": 0.21219111230568696,
    "threshold": 0.7267483830451957,
    "trained_at": "2026-02-12T22:48:35.549499",
    "confusion_matrix": {
      "total_samples": 4187,
      "TP": 210,
      "FP": 7,
      "TN": 3970,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.77,
      "recall": 100,
      "f1_score": 98.36,
      "FPR": 0.18,
      "threshold_used": 0.7267483830451957,
      "val_threshold": 0.745494437217712
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_22_66-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_22",
    "craft_id": "66-2",
    "data_size": 4233,
    "best_val_loss": 0.2136099865146008,
    "threshold": 0.5003567814826957,
    "trained_at": "2026-02-12T22:55:22.569143",
    "confusion_matrix": {
      "total_samples": 837,
      "TP": 36,
      "FP": 0,
      "TN": 795,
      "FN": 6,
      "accuracy": 99.28,
      "precision": 100,
      "recall": 85.71,
      "f1_score": 92.31,
      "FPR": 0,
      "threshold_used": 0.5003567814826957,
      "val_threshold": 0.42561510801315294
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_2",
    "model_type": "lstm",
    "equipment": "opcua_multi_39",
    "craft_id": "2",
    "data_size": 5989,
    "best_val_loss": 0.21617253225058417,
    "threshold": 0.7609837085008617,
    "trained_at": "2026-02-12T23:19:36.718882",
    "confusion_matrix": {
      "total_samples": 1188,
      "TP": 60,
      "FP": 8,
      "TN": 1120,
      "FN": 0,
      "accuracy": 99.33,
      "precision": 88.24,
      "recall": 100,
      "f1_score": 93.75,
      "FPR": 0.71,
      "threshold_used": 0.7609837085008617,
      "val_threshold": 0.8271363794803609
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_31",
    "model_type": "lstm",
    "equipment": "opcua_multi_33",
    "craft_id": "31",
    "data_size": 4961,
    "best_val_loss": 0.22667943121579268,
    "threshold": 1.042687177658081,
    "trained_at": "2026-02-12T22:24:01.925546",
    "confusion_matrix": {
      "total_samples": 983,
      "TP": 50,
      "FP": 3,
      "TN": 930,
      "FN": 0,
      "accuracy": 99.69,
      "precision": 94.34,
      "recall": 100,
      "f1_score": 97.09,
      "FPR": 0.32,
      "threshold_used": 1.042687177658081,
      "val_threshold": 1.0628787279129028
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_84",
    "model_type": "lstm",
    "equipment": "opcua_multi_40",
    "craft_id": "84",
    "data_size": 7318,
    "best_val_loss": 0.22674861706106667,
    "threshold": 0.4826966047286988,
    "trained_at": "2026-02-12T23:18:04.074477",
    "confusion_matrix": {
      "total_samples": 1454,
      "TP": 68,
      "FP": 0,
      "TN": 1381,
      "FN": 5,
      "accuracy": 99.66,
      "precision": 100,
      "recall": 93.15,
      "f1_score": 96.45,
      "FPR": 0,
      "threshold_used": 0.4826966047286988,
      "val_threshold": 0.48039842396974564
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_29",
    "model_type": "lstm",
    "equipment": "opcua_multi_07",
    "craft_id": "29",
    "data_size": 6026,
    "best_val_loss": 0.22744411250021945,
    "threshold": 0.8876861333847046,
    "trained_at": "2026-02-12T23:15:00.395808",
    "confusion_matrix": {
      "total_samples": 1196,
      "TP": 59,
      "FP": 0,
      "TN": 1136,
      "FN": 1,
      "accuracy": 99.92,
      "precision": 100,
      "recall": 98.33,
      "f1_score": 99.16,
      "FPR": 0,
      "threshold_used": 0.8876861333847046,
      "val_threshold": 0.8639834672212601
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_24_111",
    "model_type": "lstm",
    "equipment": "opcua_multi_24",
    "craft_id": "111",
    "data_size": 2917,
    "best_val_loss": 0.23176517381693013,
    "threshold": 0.4115246579051016,
    "trained_at": "2026-02-12T22:49:50.587455",
    "confusion_matrix": {
      "total_samples": 574,
      "TP": 29,
      "FP": 1,
      "TN": 544,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.67,
      "recall": 100,
      "f1_score": 98.31,
      "FPR": 0.18,
      "threshold_used": 0.4115246579051016,
      "val_threshold": 0.4125348314642907
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_91",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "91",
    "data_size": 2596,
    "best_val_loss": 0.2347694707851784,
    "threshold": 1.0795623302459714,
    "trained_at": "2026-02-12T22:41:44.365874",
    "confusion_matrix": {
      "total_samples": 510,
      "TP": 25,
      "FP": 0,
      "TN": 484,
      "FN": 1,
      "accuracy": 99.8,
      "precision": 100,
      "recall": 96.15,
      "f1_score": 98.04,
      "FPR": 0,
      "threshold_used": 1.0795623302459714,
      "val_threshold": 1.053586161136627
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_124",
    "model_type": "lstm",
    "equipment": "opcua_multi_27",
    "craft_id": "124",
    "data_size": 5123,
    "best_val_loss": 0.2384674158883212,
    "threshold": 0.3963390767574309,
    "trained_at": "2026-02-12T23:08:05.698970",
    "confusion_matrix": {
      "total_samples": 1015,
      "TP": 51,
      "FP": 9,
      "TN": 955,
      "FN": 0,
      "accuracy": 99.11,
      "precision": 85,
      "recall": 100,
      "f1_score": 91.89,
      "FPR": 0.93,
      "threshold_used": 0.3963390767574309,
      "val_threshold": 0.45077698230743357
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_03_MA120IIIE.09",
    "model_type": "lstm",
    "equipment": "opcua_multi_dongtan_03",
    "craft_id": "MA120IIIE.09",
    "data_size": 289200,
    "best_val_loss": 0.24344623541867424,
    "threshold": 0.17830986902117693,
    "trained_at": "2026-02-12T19:50:45.988482",
    "confusion_matrix": {
      "total_samples": 57831,
      "TP": 2834,
      "FP": 0,
      "TN": 54939,
      "FN": 58,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 97.99,
      "f1_score": 98.98,
      "FPR": 0,
      "threshold_used": 0.17830986902117693,
      "val_threshold": 0.17637783288955688
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_38_71",
    "model_type": "lstm",
    "equipment": "opcua_multi_38",
    "craft_id": "71",
    "data_size": 1473,
    "best_val_loss": 0.26401766303338503,
    "threshold": 0.7966950833797454,
    "trained_at": "2026-02-12T23:13:00.985621",
    "confusion_matrix": {
      "total_samples": 285,
      "TP": 15,
      "FP": 11,
      "TN": 259,
      "FN": 0,
      "accuracy": 96.14,
      "precision": 57.69,
      "recall": 100,
      "f1_score": 73.17,
      "FPR": 4.07,
      "threshold_used": 0.7966950833797454,
      "val_threshold": 0.8342336297035219
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_39-2",
    "model_type": "lstm",
    "equipment": "opcua_multi_29",
    "craft_id": "39-2",
    "data_size": 4244,
    "best_val_loss": 0.2713355583641611,
    "threshold": 0.7497116029262543,
    "trained_at": "2026-02-12T22:50:27.212382",
    "confusion_matrix": {
      "total_samples": 839,
      "TP": 42,
      "FP": 12,
      "TN": 785,
      "FN": 0,
      "accuracy": 98.57,
      "precision": 77.78,
      "recall": 100,
      "f1_score": 87.5,
      "FPR": 1.51,
      "threshold_used": 0.7497116029262543,
      "val_threshold": 1.760962939262389
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_32",
    "model_type": "lstm",
    "equipment": "opcua_multi_07",
    "craft_id": "32",
    "data_size": 51414,
    "best_val_loss": 0.295267619188974,
    "threshold": 0.14435772299766533,
    "trained_at": "2026-02-12T22:19:03.449146",
    "confusion_matrix": {
      "total_samples": 10273,
      "TP": 514,
      "FP": 0,
      "TN": 9759,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.14435772299766533,
      "val_threshold": 0.14436759650707243
    },
    "training_history": []
  }
]
  },
  ae: {
    total_count: 147,
    avg_val_loss: 0.13,
    avg_accuracy: 99.66,
    avg_precision: 96.6,
    avg_recall: 97.29,
    avg_f1: 96.73,
    avg_fpr: 0.22,
    total_data: 5319262,
    models: [
  {
    "model_id": "opcua_multi_08_26",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "26",
    "data_size": 18759,
    "best_val_loss": 0.025560467025396157,
    "threshold": 0.06764054000377633,
    "trained_at": "2026-02-13T11:33:25.517784",
    "confusion_matrix": {
      "total_samples": 3752,
      "TP": 170,
      "FP": 0,
      "TN": 3564,
      "FN": 18,
      "accuracy": 99.52,
      "precision": 100,
      "recall": 90.43,
      "f1_score": 94.97,
      "FPR": 0,
      "threshold_used": 0.06764054000377633,
      "val_threshold": 0.06502059213817118
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_68",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "68",
    "data_size": 4914,
    "best_val_loss": 0.031327741095532845,
    "threshold": 0.09341620281338692,
    "trained_at": "2026-02-13T11:39:45.474607",
    "confusion_matrix": {
      "total_samples": 983,
      "TP": 48,
      "FP": 0,
      "TN": 933,
      "FN": 2,
      "accuracy": 99.8,
      "precision": 100,
      "recall": 96,
      "f1_score": 97.96,
      "FPR": 0,
      "threshold_used": 0.09341620281338692,
      "val_threshold": 0.09021015167236325
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_36_25-1",
    "model_type": "ae",
    "equipment": "opcua_multi_36",
    "craft_id": "25-1",
    "data_size": 2221,
    "best_val_loss": 0.032873415285616776,
    "threshold": 0.09769978187978268,
    "trained_at": "2026-02-13T11:38:28.718180",
    "confusion_matrix": {
      "total_samples": 445,
      "TP": 23,
      "FP": 0,
      "TN": 422,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.09769978187978268,
      "val_threshold": 0.09857681989669795
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_72",
    "model_type": "ae",
    "equipment": "opcua_multi_07",
    "craft_id": "72",
    "data_size": 7393,
    "best_val_loss": 0.03339252808207471,
    "threshold": 0.1350662261247635,
    "trained_at": "2026-02-13T11:46:06.764639",
    "confusion_matrix": {
      "total_samples": 1479,
      "TP": 73,
      "FP": 4,
      "TN": 1402,
      "FN": 0,
      "accuracy": 99.73,
      "precision": 94.81,
      "recall": 100,
      "f1_score": 97.34,
      "FPR": 0.28,
      "threshold_used": 0.1350662261247635,
      "val_threshold": 0.13577596843242645
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_62-2",
    "model_type": "ae",
    "equipment": "opcua_multi_02",
    "craft_id": "62-2",
    "data_size": 12364,
    "best_val_loss": 0.03875305868377943,
    "threshold": 0.12067201733589172,
    "trained_at": "2026-02-13T11:33:15.370499",
    "confusion_matrix": {
      "total_samples": 2473,
      "TP": 100,
      "FP": 0,
      "TN": 2349,
      "FN": 24,
      "accuracy": 99.03,
      "precision": 100,
      "recall": 80.65,
      "f1_score": 89.29,
      "FPR": 0,
      "threshold_used": 0.12067201733589172,
      "val_threshold": 0.11104654520750049
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_95",
    "model_type": "ae",
    "equipment": "opcua_multi_20",
    "craft_id": "95",
    "data_size": 5703,
    "best_val_loss": 0.04034378707709279,
    "threshold": 0.07041304931044576,
    "trained_at": "2026-02-13T10:57:35.724452",
    "confusion_matrix": {
      "total_samples": 1141,
      "TP": 53,
      "FP": 0,
      "TN": 1084,
      "FN": 4,
      "accuracy": 99.65,
      "precision": 100,
      "recall": 92.98,
      "f1_score": 96.36,
      "FPR": 0,
      "threshold_used": 0.07041304931044576,
      "val_threshold": 0.06770355999469757
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_16_27",
    "model_type": "ae",
    "equipment": "opcua_multi_16",
    "craft_id": "27",
    "data_size": 3302,
    "best_val_loss": 0.043302205818143084,
    "threshold": 0.11055774986743927,
    "trained_at": "2026-02-13T11:34:31.455467",
    "confusion_matrix": {
      "total_samples": 661,
      "TP": 33,
      "FP": 2,
      "TN": 626,
      "FN": 0,
      "accuracy": 99.7,
      "precision": 94.29,
      "recall": 100,
      "f1_score": 97.06,
      "FPR": 0.32,
      "threshold_used": 0.11055774986743927,
      "val_threshold": 0.11409717798233032
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_30",
    "model_type": "ae",
    "equipment": "opcua_multi_10",
    "craft_id": "30",
    "data_size": 17825,
    "best_val_loss": 0.0441080507669509,
    "threshold": 0.1073288723826408,
    "trained_at": "2026-02-13T11:36:15.423578",
    "confusion_matrix": {
      "total_samples": 3565,
      "TP": 174,
      "FP": 0,
      "TN": 3386,
      "FN": 5,
      "accuracy": 99.86,
      "precision": 100,
      "recall": 97.21,
      "f1_score": 98.59,
      "FPR": 0,
      "threshold_used": 0.1073288723826408,
      "val_threshold": 0.10536226630210871
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_26_60-2",
    "model_type": "ae",
    "equipment": "opcua_multi_26",
    "craft_id": "60-2",
    "data_size": 12612,
    "best_val_loss": 0.045121264833332383,
    "threshold": 0.0648079439997673,
    "trained_at": "2026-02-13T11:16:24.826255",
    "confusion_matrix": {
      "total_samples": 2523,
      "TP": 123,
      "FP": 0,
      "TN": 2396,
      "FN": 4,
      "accuracy": 99.84,
      "precision": 100,
      "recall": 96.85,
      "f1_score": 98.4,
      "FPR": 0,
      "threshold_used": 0.0648079439997673,
      "val_threshold": 0.06416932120919229
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_103",
    "model_type": "ae",
    "equipment": "opcua_multi_19",
    "craft_id": "103",
    "data_size": 25739,
    "best_val_loss": 0.051291379721570406,
    "threshold": 0.13179437816143036,
    "trained_at": "2026-02-13T11:30:55.419865",
    "confusion_matrix": {
      "total_samples": 5148,
      "TP": 251,
      "FP": 0,
      "TN": 4890,
      "FN": 7,
      "accuracy": 99.86,
      "precision": 100,
      "recall": 97.29,
      "f1_score": 98.63,
      "FPR": 0,
      "threshold_used": 0.13179437816143036,
      "val_threshold": 0.13009237051010117
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_17_21",
    "model_type": "ae",
    "equipment": "opcua_multi_17",
    "craft_id": "21",
    "data_size": 13905,
    "best_val_loss": 0.0521474961661598,
    "threshold": 0.05100843999534846,
    "trained_at": "2026-02-13T11:43:21.961379",
    "confusion_matrix": {
      "total_samples": 2781,
      "TP": 126,
      "FP": 0,
      "TN": 2643,
      "FN": 12,
      "accuracy": 99.57,
      "precision": 100,
      "recall": 91.3,
      "f1_score": 95.45,
      "FPR": 0,
      "threshold_used": 0.05100843999534846,
      "val_threshold": 0.047799523919820786
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_56",
    "model_type": "ae",
    "equipment": "opcua_multi_18",
    "craft_id": "56",
    "data_size": 9493,
    "best_val_loss": 0.05271694499836463,
    "threshold": 0.04098580945283174,
    "trained_at": "2026-02-13T11:36:39.266204",
    "confusion_matrix": {
      "total_samples": 1899,
      "TP": 95,
      "FP": 9,
      "TN": 1795,
      "FN": 0,
      "accuracy": 99.53,
      "precision": 91.35,
      "recall": 100,
      "f1_score": 95.48,
      "FPR": 0.5,
      "threshold_used": 0.04098580945283174,
      "val_threshold": 0.04264228790998457
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_34",
    "model_type": "ae",
    "equipment": "opcua_multi_06",
    "craft_id": "34",
    "data_size": 37248,
    "best_val_loss": 0.05284555329672442,
    "threshold": 0.11483906172215913,
    "trained_at": "2026-02-13T11:32:05.510438",
    "confusion_matrix": {
      "total_samples": 7450,
      "TP": 373,
      "FP": 42,
      "TN": 7035,
      "FN": 0,
      "accuracy": 99.44,
      "precision": 89.88,
      "recall": 100,
      "f1_score": 94.67,
      "FPR": 0.59,
      "threshold_used": 0.11483906172215913,
      "val_threshold": 0.11839059554040428
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_72",
    "model_type": "ae",
    "equipment": "opcua_multi_09",
    "craft_id": "72",
    "data_size": 9009,
    "best_val_loss": 0.05557152984475719,
    "threshold": 0.1225138247013092,
    "trained_at": "2026-02-13T11:45:47.138902",
    "confusion_matrix": {
      "total_samples": 1802,
      "TP": 91,
      "FP": 0,
      "TN": 1711,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.1225138247013092,
      "val_threshold": 0.12388242706656429
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_30_70",
    "model_type": "ae",
    "equipment": "opcua_multi_30",
    "craft_id": "70",
    "data_size": 30842,
    "best_val_loss": 0.05861209376421792,
    "threshold": 0.16192861199378955,
    "trained_at": "2026-02-13T11:12:57.951908",
    "confusion_matrix": {
      "total_samples": 6169,
      "TP": 309,
      "FP": 5,
      "TN": 5855,
      "FN": 0,
      "accuracy": 99.92,
      "precision": 98.41,
      "recall": 100,
      "f1_score": 99.2,
      "FPR": 0.09,
      "threshold_used": 0.16192861199378955,
      "val_threshold": 0.1636271804571149
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_124",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "124",
    "data_size": 10144,
    "best_val_loss": 0.05874090241300407,
    "threshold": 0.15014363527297964,
    "trained_at": "2026-02-13T11:44:22.933396",
    "confusion_matrix": {
      "total_samples": 2029,
      "TP": 102,
      "FP": 14,
      "TN": 1913,
      "FN": 0,
      "accuracy": 99.31,
      "precision": 87.93,
      "recall": 100,
      "f1_score": 93.58,
      "FPR": 0.73,
      "threshold_used": 0.15014363527297964,
      "val_threshold": 0.1556986093521118
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_100",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "100",
    "data_size": 2390,
    "best_val_loss": 0.05884513250361177,
    "threshold": 0.07113030925393081,
    "trained_at": "2026-02-13T11:20:01.258253",
    "confusion_matrix": {
      "total_samples": 478,
      "TP": 24,
      "FP": 2,
      "TN": 452,
      "FN": 0,
      "accuracy": 99.58,
      "precision": 92.31,
      "recall": 100,
      "f1_score": 96,
      "FPR": 0.44,
      "threshold_used": 0.07113030925393081,
      "val_threshold": 0.07264671772718428
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_13_33",
    "model_type": "ae",
    "equipment": "opcua_multi_13",
    "craft_id": "33",
    "data_size": 6697,
    "best_val_loss": 0.058962564971019975,
    "threshold": 0.14322171211242657,
    "trained_at": "2026-02-13T10:57:52.472668",
    "confusion_matrix": {
      "total_samples": 1340,
      "TP": 62,
      "FP": 0,
      "TN": 1273,
      "FN": 5,
      "accuracy": 99.63,
      "precision": 100,
      "recall": 92.54,
      "f1_score": 96.13,
      "FPR": 0,
      "threshold_used": 0.14322171211242657,
      "val_threshold": 0.13377678841352456
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_69",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "69",
    "data_size": 19535,
    "best_val_loss": 0.05948107771619311,
    "threshold": 0.15454129576683043,
    "trained_at": "2026-02-13T11:38:35.361850",
    "confusion_matrix": {
      "total_samples": 3907,
      "TP": 195,
      "FP": 3,
      "TN": 3709,
      "FN": 0,
      "accuracy": 99.92,
      "precision": 98.48,
      "recall": 100,
      "f1_score": 99.23,
      "FPR": 0.08,
      "threshold_used": 0.15454129576683043,
      "val_threshold": 0.1550036519765854
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_14_97-2",
    "model_type": "ae",
    "equipment": "opcua_multi_14",
    "craft_id": "97-2",
    "data_size": 87740,
    "best_val_loss": 0.06019234919085409,
    "threshold": 0.11797301098704331,
    "trained_at": "2026-02-13T10:45:35.710138",
    "confusion_matrix": {
      "total_samples": 17548,
      "TP": 878,
      "FP": 34,
      "TN": 16636,
      "FN": 0,
      "accuracy": 99.81,
      "precision": 96.27,
      "recall": 100,
      "f1_score": 98.1,
      "FPR": 0.2,
      "threshold_used": 0.11797301098704331,
      "val_threshold": 0.12020452916622154
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_93",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "93",
    "data_size": 17183,
    "best_val_loss": 0.06073426133618388,
    "threshold": 0.08180406130850315,
    "trained_at": "2026-02-13T11:40:50.249925",
    "confusion_matrix": {
      "total_samples": 3437,
      "TP": 172,
      "FP": 0,
      "TN": 3265,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.08180406130850315,
      "val_threshold": 0.0816521853208541
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_30_13",
    "model_type": "ae",
    "equipment": "opcua_multi_30",
    "craft_id": "13",
    "data_size": 50942,
    "best_val_loss": 0.062445596464483576,
    "threshold": 0.07450236231088657,
    "trained_at": "2026-02-13T11:26:11.087118",
    "confusion_matrix": {
      "total_samples": 10189,
      "TP": 505,
      "FP": 0,
      "TN": 9679,
      "FN": 5,
      "accuracy": 99.95,
      "precision": 100,
      "recall": 99.02,
      "f1_score": 99.51,
      "FPR": 0,
      "threshold_used": 0.07450236231088657,
      "val_threshold": 0.07401190698146821
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_104",
    "model_type": "ae",
    "equipment": "opcua_multi_19",
    "craft_id": "104",
    "data_size": 23742,
    "best_val_loss": 0.06363028803262542,
    "threshold": 0.17802042067050913,
    "trained_at": "2026-02-13T11:35:36.412390",
    "confusion_matrix": {
      "total_samples": 4749,
      "TP": 232,
      "FP": 0,
      "TN": 4511,
      "FN": 6,
      "accuracy": 99.87,
      "precision": 100,
      "recall": 97.48,
      "f1_score": 98.72,
      "FPR": 0,
      "threshold_used": 0.17802042067050913,
      "val_threshold": 0.1760425984859466
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_90",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "90",
    "data_size": 3456,
    "best_val_loss": 0.0636375651969386,
    "threshold": 0.09333550184965134,
    "trained_at": "2026-02-13T11:40:46.008432",
    "confusion_matrix": {
      "total_samples": 692,
      "TP": 35,
      "FP": 10,
      "TN": 647,
      "FN": 0,
      "accuracy": 98.55,
      "precision": 77.78,
      "recall": 100,
      "f1_score": 87.5,
      "FPR": 1.52,
      "threshold_used": 0.09333550184965134,
      "val_threshold": 0.1419332951307296
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_22_66-2",
    "model_type": "ae",
    "equipment": "opcua_multi_22",
    "craft_id": "66-2",
    "data_size": 4233,
    "best_val_loss": 0.06601206225111042,
    "threshold": 0.17685149982571602,
    "trained_at": "2026-02-13T11:37:49.248980",
    "confusion_matrix": {
      "total_samples": 847,
      "TP": 43,
      "FP": 8,
      "TN": 796,
      "FN": 0,
      "accuracy": 99.06,
      "precision": 84.31,
      "recall": 100,
      "f1_score": 91.49,
      "FPR": 1,
      "threshold_used": 0.17685149982571602,
      "val_threshold": 0.19229246526956548
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_13_26",
    "model_type": "ae",
    "equipment": "opcua_multi_13",
    "craft_id": "26",
    "data_size": 75219,
    "best_val_loss": 0.0674798472372657,
    "threshold": 0.09833280369639395,
    "trained_at": "2026-02-13T11:08:11.966557",
    "confusion_matrix": {
      "total_samples": 15044,
      "TP": 751,
      "FP": 0,
      "TN": 14291,
      "FN": 2,
      "accuracy": 99.99,
      "precision": 100,
      "recall": 99.73,
      "f1_score": 99.86,
      "FPR": 0,
      "threshold_used": 0.09833280369639395,
      "val_threshold": 0.09813209138810612
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_29",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "29",
    "data_size": 15378,
    "best_val_loss": 0.06853188047977589,
    "threshold": 0.05995606668293469,
    "trained_at": "2026-02-13T11:38:15.551154",
    "confusion_matrix": {
      "total_samples": 3076,
      "TP": 141,
      "FP": 0,
      "TN": 2922,
      "FN": 13,
      "accuracy": 99.58,
      "precision": 100,
      "recall": 91.56,
      "f1_score": 95.59,
      "FPR": 0,
      "threshold_used": 0.05995606668293469,
      "val_threshold": 0.056594246067106724
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_01_62-1",
    "model_type": "ae",
    "equipment": "opcua_multi_01",
    "craft_id": "62-1",
    "data_size": 14468,
    "best_val_loss": 0.06967698806882645,
    "threshold": 0.07163399793207646,
    "trained_at": "2026-02-13T11:05:40.387932",
    "confusion_matrix": {
      "total_samples": 2894,
      "TP": 136,
      "FP": 0,
      "TN": 2749,
      "FN": 9,
      "accuracy": 99.69,
      "precision": 100,
      "recall": 93.79,
      "f1_score": 96.8,
      "FPR": 0,
      "threshold_used": 0.07163399793207646,
      "val_threshold": 0.06987047344446179
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_70",
    "model_type": "ae",
    "equipment": "opcua_multi_34",
    "craft_id": "70",
    "data_size": 7831,
    "best_val_loss": 0.07359721902436943,
    "threshold": 0.1824776977300644,
    "trained_at": "2026-02-13T11:34:31.142234",
    "confusion_matrix": {
      "total_samples": 1567,
      "TP": 65,
      "FP": 0,
      "TN": 1488,
      "FN": 14,
      "accuracy": 99.11,
      "precision": 100,
      "recall": 82.28,
      "f1_score": 90.28,
      "FPR": 0,
      "threshold_used": 0.1824776977300644,
      "val_threshold": 0.1665064215660093
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_94-1",
    "model_type": "ae",
    "equipment": "opcua_multi_10",
    "craft_id": "94-1",
    "data_size": 19506,
    "best_val_loss": 0.0758902673031476,
    "threshold": 0.2203551121056078,
    "trained_at": "2026-02-13T10:53:42.962449",
    "confusion_matrix": {
      "total_samples": 3902,
      "TP": 196,
      "FP": 24,
      "TN": 3682,
      "FN": 0,
      "accuracy": 99.38,
      "precision": 89.09,
      "recall": 100,
      "f1_score": 94.23,
      "FPR": 0.65,
      "threshold_used": 0.2203551121056078,
      "val_threshold": 0.25202587842941265
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_29",
    "model_type": "ae",
    "equipment": "opcua_multi_07",
    "craft_id": "29",
    "data_size": 6026,
    "best_val_loss": 0.07635784376517654,
    "threshold": 0.14979122877120976,
    "trained_at": "2026-02-13T11:45:08.444622",
    "confusion_matrix": {
      "total_samples": 1206,
      "TP": 54,
      "FP": 0,
      "TN": 1145,
      "FN": 7,
      "accuracy": 99.42,
      "precision": 100,
      "recall": 88.52,
      "f1_score": 93.91,
      "FPR": 0,
      "threshold_used": 0.14979122877120976,
      "val_threshold": 0.1428646594285965
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_100",
    "model_type": "ae",
    "equipment": "opcua_multi_19",
    "craft_id": "100",
    "data_size": 10337,
    "best_val_loss": 0.0774876547173905,
    "threshold": 0.1718055874109268,
    "trained_at": "2026-02-13T11:41:53.517260",
    "confusion_matrix": {
      "total_samples": 2068,
      "TP": 104,
      "FP": 15,
      "TN": 1949,
      "FN": 0,
      "accuracy": 99.27,
      "precision": 87.39,
      "recall": 100,
      "f1_score": 93.27,
      "FPR": 0.76,
      "threshold_used": 0.1718055874109268,
      "val_threshold": 0.18140161931514734
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_QV-HOUSING",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "QV-HOUSING",
    "data_size": 5047,
    "best_val_loss": 0.07781274745074829,
    "threshold": 0.13955443799495698,
    "trained_at": "2026-02-13T11:47:18.619607",
    "confusion_matrix": {
      "total_samples": 1010,
      "TP": 51,
      "FP": 8,
      "TN": 951,
      "FN": 0,
      "accuracy": 99.21,
      "precision": 86.44,
      "recall": 100,
      "f1_score": 92.73,
      "FPR": 0.83,
      "threshold_used": 0.13955443799495698,
      "val_threshold": 0.14118318036198607
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_40-2",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "40-2",
    "data_size": 35260,
    "best_val_loss": 0.07893996264614372,
    "threshold": 0.12676982060074798,
    "trained_at": "2026-02-13T11:25:55.028050",
    "confusion_matrix": {
      "total_samples": 7052,
      "TP": 353,
      "FP": 16,
      "TN": 6683,
      "FN": 0,
      "accuracy": 99.77,
      "precision": 95.66,
      "recall": 100,
      "f1_score": 97.78,
      "FPR": 0.24,
      "threshold_used": 0.12676982060074798,
      "val_threshold": 0.12882747873663902
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_31",
    "model_type": "ae",
    "equipment": "opcua_multi_33",
    "craft_id": "31",
    "data_size": 4961,
    "best_val_loss": 0.07989783654991098,
    "threshold": 0.09299603216350058,
    "trained_at": "2026-02-13T11:27:44.457073",
    "confusion_matrix": {
      "total_samples": 993,
      "TP": 47,
      "FP": 0,
      "TN": 943,
      "FN": 3,
      "accuracy": 99.7,
      "precision": 100,
      "recall": 94,
      "f1_score": 96.91,
      "FPR": 0,
      "threshold_used": 0.09299603216350058,
      "val_threshold": 0.08989130109548568
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_75",
    "model_type": "ae",
    "equipment": "opcua_multi_40",
    "craft_id": "75",
    "data_size": 35877,
    "best_val_loss": 0.08290301005427654,
    "threshold": 0.10054417699575424,
    "trained_at": "2026-02-13T11:32:19.851802",
    "confusion_matrix": {
      "total_samples": 7176,
      "TP": 345,
      "FP": 0,
      "TN": 6817,
      "FN": 14,
      "accuracy": 99.8,
      "precision": 100,
      "recall": 96.1,
      "f1_score": 98.01,
      "FPR": 0,
      "threshold_used": 0.10054417699575424,
      "val_threshold": 0.09862544760107994
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_C2-CASE-M",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "C2-CASE-M",
    "data_size": 21885,
    "best_val_loss": 0.08399803316535975,
    "threshold": 0.14027482271194458,
    "trained_at": "2026-02-13T11:37:20.504851",
    "confusion_matrix": {
      "total_samples": 4377,
      "TP": 217,
      "FP": 0,
      "TN": 4158,
      "FN": 2,
      "accuracy": 99.95,
      "precision": 100,
      "recall": 99.09,
      "f1_score": 99.54,
      "FPR": 0,
      "threshold_used": 0.14027482271194458,
      "val_threshold": 0.13991257548332212
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_24_108",
    "model_type": "ae",
    "equipment": "opcua_multi_24",
    "craft_id": "108",
    "data_size": 3975,
    "best_val_loss": 0.08478057155819059,
    "threshold": 0.09226992726325989,
    "trained_at": "2026-02-13T11:22:59.848852",
    "confusion_matrix": {
      "total_samples": 795,
      "TP": 39,
      "FP": 3,
      "TN": 753,
      "FN": 0,
      "accuracy": 99.62,
      "precision": 92.86,
      "recall": 100,
      "f1_score": 96.3,
      "FPR": 0.4,
      "threshold_used": 0.09226992726325989,
      "val_threshold": 0.09661237895488739
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_33",
    "model_type": "ae",
    "equipment": "opcua_multi_34",
    "craft_id": "33",
    "data_size": 39823,
    "best_val_loss": 0.0860907058096482,
    "threshold": 0.11785345636308182,
    "trained_at": "2026-02-13T11:15:53.080433",
    "confusion_matrix": {
      "total_samples": 7965,
      "TP": 399,
      "FP": 10,
      "TN": 7556,
      "FN": 0,
      "accuracy": 99.87,
      "precision": 97.56,
      "recall": 100,
      "f1_score": 98.76,
      "FPR": 0.13,
      "threshold_used": 0.11785345636308182,
      "val_threshold": 0.11869497150182723
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_02_MA120IIIE.09",
    "model_type": "ae",
    "equipment": "opcua_multi_dongtan_02",
    "craft_id": "MA120IIIE.09",
    "data_size": 150445,
    "best_val_loss": 0.08612972668722257,
    "threshold": 0.20479262992739677,
    "trained_at": "2026-02-13T10:38:14.231964",
    "confusion_matrix": {
      "total_samples": 30089,
      "TP": 1505,
      "FP": 0,
      "TN": 28584,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.20479262992739677,
      "val_threshold": 0.2048777282238003
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_22",
    "model_type": "ae",
    "equipment": "opcua_multi_09",
    "craft_id": "22",
    "data_size": 17862,
    "best_val_loss": 0.08686224611310808,
    "threshold": 0.1025273650884627,
    "trained_at": "2026-02-13T11:28:28.706867",
    "confusion_matrix": {
      "total_samples": 3573,
      "TP": 179,
      "FP": 14,
      "TN": 3380,
      "FN": 0,
      "accuracy": 99.61,
      "precision": 92.75,
      "recall": 100,
      "f1_score": 96.24,
      "FPR": 0.41,
      "threshold_used": 0.1025273650884627,
      "val_threshold": 0.10591834038496004
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_92",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "92",
    "data_size": 15427,
    "best_val_loss": 0.08719476874934645,
    "threshold": 0.2975768744945526,
    "trained_at": "2026-02-13T11:42:48.575049",
    "confusion_matrix": {
      "total_samples": 3086,
      "TP": 155,
      "FP": 10,
      "TN": 2921,
      "FN": 0,
      "accuracy": 99.68,
      "precision": 93.94,
      "recall": 100,
      "f1_score": 96.88,
      "FPR": 0.34,
      "threshold_used": 0.2975768744945526,
      "val_threshold": 0.5502127707004547
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_104",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "104",
    "data_size": 5989,
    "best_val_loss": 0.08788473022252768,
    "threshold": 0.2216477319598198,
    "trained_at": "2026-02-13T11:46:43.245190",
    "confusion_matrix": {
      "total_samples": 1198,
      "TP": 53,
      "FP": 0,
      "TN": 1138,
      "FN": 7,
      "accuracy": 99.42,
      "precision": 100,
      "recall": 88.33,
      "f1_score": 93.8,
      "FPR": 0,
      "threshold_used": 0.2216477319598198,
      "val_threshold": 0.19145800471305832
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_72",
    "model_type": "ae",
    "equipment": "opcua_multi_06",
    "craft_id": "72",
    "data_size": 44172,
    "best_val_loss": 0.08920761206723332,
    "threshold": 0.05817543789744368,
    "trained_at": "2026-02-13T11:30:06.649652",
    "confusion_matrix": {
      "total_samples": 8835,
      "TP": 442,
      "FP": 23,
      "TN": 8370,
      "FN": 0,
      "accuracy": 99.74,
      "precision": 95.05,
      "recall": 100,
      "f1_score": 97.46,
      "FPR": 0.27,
      "threshold_used": 0.05817543789744368,
      "val_threshold": 0.05932566225528711
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_23_XMA-3",
    "model_type": "ae",
    "equipment": "opcua_multi_23",
    "craft_id": "XMA-3",
    "data_size": 64757,
    "best_val_loss": 0.08926599828262916,
    "threshold": 0.15402224957942945,
    "trained_at": "2026-02-13T11:14:40.373575",
    "confusion_matrix": {
      "total_samples": 12952,
      "TP": 620,
      "FP": 0,
      "TN": 12304,
      "FN": 28,
      "accuracy": 99.78,
      "precision": 100,
      "recall": 95.68,
      "f1_score": 97.79,
      "FPR": 0,
      "threshold_used": 0.15402224957942945,
      "val_threshold": 0.15186533778905867
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_25-1",
    "model_type": "ae",
    "equipment": "opcua_multi_07",
    "craft_id": "25-1",
    "data_size": 62770,
    "best_val_loss": 0.09045406033682447,
    "threshold": 0.13323885202407837,
    "trained_at": "2026-02-13T11:17:39.912925",
    "confusion_matrix": {
      "total_samples": 12554,
      "TP": 565,
      "FP": 0,
      "TN": 11926,
      "FN": 63,
      "accuracy": 99.5,
      "precision": 100,
      "recall": 89.97,
      "f1_score": 94.72,
      "FPR": 0,
      "threshold_used": 0.13323885202407837,
      "val_threshold": 0.12797322869300817
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_23_72",
    "model_type": "ae",
    "equipment": "opcua_multi_23",
    "craft_id": "72",
    "data_size": 9731,
    "best_val_loss": 0.0905973247946472,
    "threshold": 0.18759621977806065,
    "trained_at": "2026-02-13T11:45:31.820867",
    "confusion_matrix": {
      "total_samples": 1947,
      "TP": 98,
      "FP": 5,
      "TN": 1844,
      "FN": 0,
      "accuracy": 99.74,
      "precision": 95.15,
      "recall": 100,
      "f1_score": 97.51,
      "FPR": 0.27,
      "threshold_used": 0.18759621977806065,
      "val_threshold": 0.1940863683819766
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_128",
    "model_type": "ae",
    "equipment": "opcua_multi_02",
    "craft_id": "128",
    "data_size": 5395,
    "best_val_loss": 0.09192872217289268,
    "threshold": 0.2002289593219757,
    "trained_at": "2026-02-13T11:47:08.952395",
    "confusion_matrix": {
      "total_samples": 1079,
      "TP": 54,
      "FP": 0,
      "TN": 1025,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.2002289593219757,
      "val_threshold": 0.19378074854612198
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_93",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "93",
    "data_size": 8724,
    "best_val_loss": 0.09242966100146573,
    "threshold": 0.12717158049345012,
    "trained_at": "2026-02-13T11:45:55.215660",
    "confusion_matrix": {
      "total_samples": 1745,
      "TP": 81,
      "FP": 0,
      "TN": 1657,
      "FN": 7,
      "accuracy": 99.6,
      "precision": 100,
      "recall": 92.05,
      "f1_score": 95.86,
      "FPR": 0,
      "threshold_used": 0.12717158049345012,
      "val_threshold": 0.11968256682157516
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_28",
    "model_type": "ae",
    "equipment": "opcua_multi_20",
    "craft_id": "28",
    "data_size": 8056,
    "best_val_loss": 0.09285843821598341,
    "threshold": 0.13789481818675994,
    "trained_at": "2026-02-13T11:40:03.888553",
    "confusion_matrix": {
      "total_samples": 1612,
      "TP": 81,
      "FP": 6,
      "TN": 1525,
      "FN": 0,
      "accuracy": 99.63,
      "precision": 93.1,
      "recall": 100,
      "f1_score": 96.43,
      "FPR": 0.39,
      "threshold_used": 0.13789481818675994,
      "val_threshold": 0.14081523567438112
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_38",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "38",
    "data_size": 4012,
    "best_val_loss": 0.09334501000828717,
    "threshold": 0.12097243964672089,
    "trained_at": "2026-02-13T11:40:26.019667",
    "confusion_matrix": {
      "total_samples": 803,
      "TP": 37,
      "FP": 0,
      "TN": 762,
      "FN": 4,
      "accuracy": 99.5,
      "precision": 100,
      "recall": 90.24,
      "f1_score": 94.87,
      "FPR": 0,
      "threshold_used": 0.12097243964672089,
      "val_threshold": 0.11150222048163357
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_68",
    "model_type": "ae",
    "equipment": "opcua_multi_19",
    "craft_id": "68",
    "data_size": 79941,
    "best_val_loss": 0.09377882387508885,
    "threshold": 0.15499679520726195,
    "trained_at": "2026-02-13T10:54:47.576499",
    "confusion_matrix": {
      "total_samples": 15989,
      "TP": 788,
      "FP": 0,
      "TN": 15189,
      "FN": 12,
      "accuracy": 99.92,
      "precision": 100,
      "recall": 98.5,
      "f1_score": 99.24,
      "FPR": 0,
      "threshold_used": 0.15499679520726195,
      "val_threshold": 0.15399358570575702
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_74",
    "model_type": "ae",
    "equipment": "opcua_multi_40",
    "craft_id": "74",
    "data_size": 42774,
    "best_val_loss": 0.09437712498536102,
    "threshold": 0.16369599252939224,
    "trained_at": "2026-02-13T11:04:39.821487",
    "confusion_matrix": {
      "total_samples": 8555,
      "TP": 428,
      "FP": 20,
      "TN": 8107,
      "FN": 0,
      "accuracy": 99.77,
      "precision": 95.54,
      "recall": 100,
      "f1_score": 97.72,
      "FPR": 0.25,
      "threshold_used": 0.16369599252939224,
      "val_threshold": 0.17300444543361643
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_82",
    "model_type": "ae",
    "equipment": "opcua_multi_40",
    "craft_id": "82",
    "data_size": 21198,
    "best_val_loss": 0.094671067075347,
    "threshold": 0.15392023026943205,
    "trained_at": "2026-02-13T11:37:37.398597",
    "confusion_matrix": {
      "total_samples": 4240,
      "TP": 212,
      "FP": 4,
      "TN": 4024,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.15,
      "recall": 100,
      "f1_score": 99.07,
      "FPR": 0.1,
      "threshold_used": 0.15392023026943205,
      "val_threshold": 0.15521018281579016
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_36-1",
    "model_type": "ae",
    "equipment": "opcua_multi_20",
    "craft_id": "36-1",
    "data_size": 2637,
    "best_val_loss": 0.09557689139337251,
    "threshold": 0.20149824321269977,
    "trained_at": "2026-02-13T11:46:59.720682",
    "confusion_matrix": {
      "total_samples": 528,
      "TP": 27,
      "FP": 12,
      "TN": 489,
      "FN": 0,
      "accuracy": 97.73,
      "precision": 69.23,
      "recall": 100,
      "f1_score": 81.82,
      "FPR": 2.4,
      "threshold_used": 0.20149824321269977,
      "val_threshold": 0.324077114462851
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_124",
    "model_type": "ae",
    "equipment": "opcua_multi_27",
    "craft_id": "124",
    "data_size": 5123,
    "best_val_loss": 0.09648791929388918,
    "threshold": 0.2132365576922893,
    "trained_at": "2026-02-13T11:42:35.638365",
    "confusion_matrix": {
      "total_samples": 1025,
      "TP": 44,
      "FP": 0,
      "TN": 973,
      "FN": 8,
      "accuracy": 99.22,
      "precision": 100,
      "recall": 84.62,
      "f1_score": 91.67,
      "FPR": 0,
      "threshold_used": 0.2132365576922893,
      "val_threshold": 0.1789632499217986
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_17_27",
    "model_type": "ae",
    "equipment": "opcua_multi_17",
    "craft_id": "27",
    "data_size": 19133,
    "best_val_loss": 0.09654664405338566,
    "threshold": 0.14734059944748878,
    "trained_at": "2026-02-13T11:39:17.712163",
    "confusion_matrix": {
      "total_samples": 3827,
      "TP": 164,
      "FP": 0,
      "TN": 3635,
      "FN": 28,
      "accuracy": 99.27,
      "precision": 100,
      "recall": 85.42,
      "f1_score": 92.14,
      "FPR": 0,
      "threshold_used": 0.14734059944748878,
      "val_threshold": 0.13822749853134153
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_36_29",
    "model_type": "ae",
    "equipment": "opcua_multi_36",
    "craft_id": "29",
    "data_size": 2376,
    "best_val_loss": 0.09663518712300212,
    "threshold": 0.09328090324997902,
    "trained_at": "2026-02-13T11:42:06.947156",
    "confusion_matrix": {
      "total_samples": 476,
      "TP": 23,
      "FP": 0,
      "TN": 453,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.09328090324997902,
      "val_threshold": 0.093204565346241
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_37_115",
    "model_type": "ae",
    "equipment": "opcua_multi_37",
    "craft_id": "115",
    "data_size": 49918,
    "best_val_loss": 0.09694126857301363,
    "threshold": 0.26753996312618256,
    "trained_at": "2026-02-13T10:39:48.906621",
    "confusion_matrix": {
      "total_samples": 9984,
      "TP": 450,
      "FP": 0,
      "TN": 9484,
      "FN": 50,
      "accuracy": 99.5,
      "precision": 100,
      "recall": 90,
      "f1_score": 94.74,
      "FPR": 0,
      "threshold_used": 0.26753996312618256,
      "val_threshold": 0.24891484156250954
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_28_123",
    "model_type": "ae",
    "equipment": "opcua_multi_28",
    "craft_id": "123",
    "data_size": 14549,
    "best_val_loss": 0.0970772308211044,
    "threshold": 0.08872116953134537,
    "trained_at": "2026-02-13T11:43:12.167213",
    "confusion_matrix": {
      "total_samples": 2910,
      "TP": 135,
      "FP": 0,
      "TN": 2764,
      "FN": 11,
      "accuracy": 99.62,
      "precision": 100,
      "recall": 92.47,
      "f1_score": 96.09,
      "FPR": 0,
      "threshold_used": 0.08872116953134537,
      "val_threshold": 0.08307595029473304
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_86",
    "model_type": "ae",
    "equipment": "opcua_multi_33",
    "craft_id": "86",
    "data_size": 58324,
    "best_val_loss": 0.09743495278389373,
    "threshold": 0.14416546076536177,
    "trained_at": "2026-02-13T11:03:19.161827",
    "confusion_matrix": {
      "total_samples": 11665,
      "TP": 551,
      "FP": 0,
      "TN": 11081,
      "FN": 33,
      "accuracy": 99.72,
      "precision": 100,
      "recall": 94.35,
      "f1_score": 97.09,
      "FPR": 0,
      "threshold_used": 0.14416546076536177,
      "val_threshold": 0.1411142021417617
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_01_DN8-GEAR3",
    "model_type": "ae",
    "equipment": "opcua_multi_01",
    "craft_id": "DN8-GEAR3",
    "data_size": 76521,
    "best_val_loss": 0.10052016018307197,
    "threshold": 0.10058075189590454,
    "trained_at": "2026-02-13T10:42:08.130323",
    "confusion_matrix": {
      "total_samples": 15305,
      "TP": 766,
      "FP": 28,
      "TN": 14511,
      "FN": 0,
      "accuracy": 99.82,
      "precision": 96.47,
      "recall": 100,
      "f1_score": 98.2,
      "FPR": 0.19,
      "threshold_used": 0.10058075189590454,
      "val_threshold": 0.10297832638025281
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_24_130",
    "model_type": "ae",
    "equipment": "opcua_multi_24",
    "craft_id": "130",
    "data_size": 39397,
    "best_val_loss": 0.10267736873953476,
    "threshold": 0.16024637520313256,
    "trained_at": "2026-02-13T10:59:55.348063",
    "confusion_matrix": {
      "total_samples": 7880,
      "TP": 383,
      "FP": 0,
      "TN": 7486,
      "FN": 11,
      "accuracy": 99.86,
      "precision": 100,
      "recall": 97.21,
      "f1_score": 98.59,
      "FPR": 0,
      "threshold_used": 0.16024637520313256,
      "val_threshold": 0.15538896843791006
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_22_62-2",
    "model_type": "ae",
    "equipment": "opcua_multi_22",
    "craft_id": "62-2",
    "data_size": 7584,
    "best_val_loss": 0.10509048840405522,
    "threshold": 0.30232818722724886,
    "trained_at": "2026-02-13T11:15:50.801738",
    "confusion_matrix": {
      "total_samples": 1517,
      "TP": 76,
      "FP": 6,
      "TN": 1435,
      "FN": 0,
      "accuracy": 99.6,
      "precision": 92.68,
      "recall": 100,
      "f1_score": 96.2,
      "FPR": 0.42,
      "threshold_used": 0.30232818722724886,
      "val_threshold": 0.32346233129501345
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_03_64",
    "model_type": "ae",
    "equipment": "opcua_multi_03",
    "craft_id": "64",
    "data_size": 108642,
    "best_val_loss": 0.10568981503233621,
    "threshold": 0.1311668306589126,
    "trained_at": "2026-02-13T10:32:30.730149",
    "confusion_matrix": {
      "total_samples": 21729,
      "TP": 1087,
      "FP": 28,
      "TN": 20614,
      "FN": 0,
      "accuracy": 99.87,
      "precision": 97.49,
      "recall": 100,
      "f1_score": 98.73,
      "FPR": 0.14,
      "threshold_used": 0.1311668306589126,
      "val_threshold": 0.13365225493907926
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_38_114",
    "model_type": "ae",
    "equipment": "opcua_multi_38",
    "craft_id": "114",
    "data_size": 53765,
    "best_val_loss": 0.10589543189328571,
    "threshold": 0.1351018153131008,
    "trained_at": "2026-02-13T10:47:16.730231",
    "confusion_matrix": {
      "total_samples": 10753,
      "TP": 538,
      "FP": 10,
      "TN": 10205,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.18,
      "recall": 100,
      "f1_score": 99.08,
      "FPR": 0.1,
      "threshold_used": 0.1351018153131008,
      "val_threshold": 0.1357052713632583
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_28_K2XX-GEAR5",
    "model_type": "ae",
    "equipment": "opcua_multi_28",
    "craft_id": "K2XX-GEAR5",
    "data_size": 23026,
    "best_val_loss": 0.1071131849775509,
    "threshold": 0.12850293666124343,
    "trained_at": "2026-02-13T10:51:26.058569",
    "confusion_matrix": {
      "total_samples": 4606,
      "TP": 221,
      "FP": 0,
      "TN": 4375,
      "FN": 10,
      "accuracy": 99.78,
      "precision": 100,
      "recall": 95.67,
      "f1_score": 97.79,
      "FPR": 0,
      "threshold_used": 0.12850293666124343,
      "val_threshold": 0.12672744318842888
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_75",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "75",
    "data_size": 11810,
    "best_val_loss": 0.10764964754952655,
    "threshold": 0.10183525867760172,
    "trained_at": "2026-02-13T11:44:40.799068",
    "confusion_matrix": {
      "total_samples": 2362,
      "TP": 115,
      "FP": 0,
      "TN": 2243,
      "FN": 4,
      "accuracy": 99.83,
      "precision": 100,
      "recall": 96.64,
      "f1_score": 98.29,
      "FPR": 0,
      "threshold_used": 0.10183525867760172,
      "val_threshold": 0.10133703909814357
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_61-2",
    "model_type": "ae",
    "equipment": "opcua_multi_27",
    "craft_id": "61-2",
    "data_size": 52304,
    "best_val_loss": 0.10808190239235316,
    "threshold": 0.13738144636154187,
    "trained_at": "2026-02-13T11:15:30.018105",
    "confusion_matrix": {
      "total_samples": 10461,
      "TP": 523,
      "FP": 33,
      "TN": 9905,
      "FN": 0,
      "accuracy": 99.68,
      "precision": 94.06,
      "recall": 100,
      "f1_score": 96.94,
      "FPR": 0.33,
      "threshold_used": 0.13738144636154187,
      "val_threshold": 0.14125089347362518
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_26_109",
    "model_type": "ae",
    "equipment": "opcua_multi_26",
    "craft_id": "109",
    "data_size": 113290,
    "best_val_loss": 0.11177276390265078,
    "threshold": 0.08764853589236735,
    "trained_at": "2026-02-13T10:57:18.968818",
    "confusion_matrix": {
      "total_samples": 22658,
      "TP": 1133,
      "FP": 13,
      "TN": 21512,
      "FN": 0,
      "accuracy": 99.94,
      "precision": 98.87,
      "recall": 100,
      "f1_score": 99.43,
      "FPR": 0.06,
      "threshold_used": 0.08764853589236735,
      "val_threshold": 0.08810456767678233
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_17_58",
    "model_type": "ae",
    "equipment": "opcua_multi_17",
    "craft_id": "58",
    "data_size": 117561,
    "best_val_loss": 0.11211834647965843,
    "threshold": 0.07494916841387746,
    "trained_at": "2026-02-13T10:36:25.089180",
    "confusion_matrix": {
      "total_samples": 23513,
      "TP": 1119,
      "FP": 0,
      "TN": 22337,
      "FN": 57,
      "accuracy": 99.76,
      "precision": 100,
      "recall": 95.15,
      "f1_score": 97.51,
      "FPR": 0,
      "threshold_used": 0.07494916841387746,
      "val_threshold": 0.0739956766366958
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_122",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "122",
    "data_size": 8375,
    "best_val_loss": 0.11304453928746394,
    "threshold": 0.20681922212243065,
    "trained_at": "2026-02-13T11:42:09.639846",
    "confusion_matrix": {
      "total_samples": 1675,
      "TP": 78,
      "FP": 0,
      "TN": 1591,
      "FN": 6,
      "accuracy": 99.64,
      "precision": 100,
      "recall": 92.86,
      "f1_score": 96.3,
      "FPR": 0,
      "threshold_used": 0.20681922212243065,
      "val_threshold": 0.19555689692497252
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_102",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "102",
    "data_size": 8960,
    "best_val_loss": 0.11382872351844396,
    "threshold": 0.1462333783507346,
    "trained_at": "2026-02-13T11:41:50.119674",
    "confusion_matrix": {
      "total_samples": 1792,
      "TP": 81,
      "FP": 0,
      "TN": 1702,
      "FN": 9,
      "accuracy": 99.5,
      "precision": 100,
      "recall": 90,
      "f1_score": 94.74,
      "FPR": 0,
      "threshold_used": 0.1462333783507346,
      "val_threshold": 0.13429497778415606
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_73",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "73",
    "data_size": 6365,
    "best_val_loss": 0.1139129626580045,
    "threshold": 0.31200782805681215,
    "trained_at": "2026-02-13T11:46:26.942839",
    "confusion_matrix": {
      "total_samples": 1273,
      "TP": 63,
      "FP": 0,
      "TN": 1209,
      "FN": 1,
      "accuracy": 99.92,
      "precision": 100,
      "recall": 98.44,
      "f1_score": 99.21,
      "FPR": 0,
      "threshold_used": 0.31200782805681215,
      "val_threshold": 0.31094376444816574
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_12_31",
    "model_type": "ae",
    "equipment": "opcua_multi_12",
    "craft_id": "31",
    "data_size": 28894,
    "best_val_loss": 0.1139346107403482,
    "threshold": 0.11400990709662435,
    "trained_at": "2026-02-13T11:13:51.599023",
    "confusion_matrix": {
      "total_samples": 5779,
      "TP": 289,
      "FP": 4,
      "TN": 5486,
      "FN": 0,
      "accuracy": 99.93,
      "precision": 98.63,
      "recall": 100,
      "f1_score": 99.31,
      "FPR": 0.07,
      "threshold_used": 0.11400990709662435,
      "val_threshold": 0.11420871466398226
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_15_98-2",
    "model_type": "ae",
    "equipment": "opcua_multi_15",
    "craft_id": "98-2",
    "data_size": 53399,
    "best_val_loss": 0.1169311834855026,
    "threshold": 0.24423539936542485,
    "trained_at": "2026-02-13T10:33:16.248957",
    "confusion_matrix": {
      "total_samples": 10680,
      "TP": 527,
      "FP": 0,
      "TN": 10146,
      "FN": 7,
      "accuracy": 99.93,
      "precision": 100,
      "recall": 98.69,
      "f1_score": 99.34,
      "FPR": 0,
      "threshold_used": 0.24423539936542485,
      "val_threshold": 0.24086484313011106
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_29",
    "model_type": "ae",
    "equipment": "opcua_multi_09",
    "craft_id": "29",
    "data_size": 38868,
    "best_val_loss": 0.11825401959679628,
    "threshold": 0.12611137330532074,
    "trained_at": "2026-02-13T11:19:43.667527",
    "confusion_matrix": {
      "total_samples": 7774,
      "TP": 389,
      "FP": 17,
      "TN": 7368,
      "FN": 0,
      "accuracy": 99.78,
      "precision": 95.81,
      "recall": 100,
      "f1_score": 97.86,
      "FPR": 0.23,
      "threshold_used": 0.12611137330532074,
      "val_threshold": 0.1308394953608513
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_72",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "72",
    "data_size": 16490,
    "best_val_loss": 0.11961692492570784,
    "threshold": 0.18541363626718502,
    "trained_at": "2026-02-13T11:41:27.521693",
    "confusion_matrix": {
      "total_samples": 3298,
      "TP": 165,
      "FP": 9,
      "TN": 3124,
      "FN": 0,
      "accuracy": 99.73,
      "precision": 94.83,
      "recall": 100,
      "f1_score": 97.35,
      "FPR": 0.29,
      "threshold_used": 0.18541363626718502,
      "val_threshold": 0.18680359348654746
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_27",
    "model_type": "ae",
    "equipment": "opcua_multi_20",
    "craft_id": "27",
    "data_size": 9665,
    "best_val_loss": 0.11993378753288694,
    "threshold": 0.0951920825988054,
    "trained_at": "2026-02-13T11:20:25.237546",
    "confusion_matrix": {
      "total_samples": 1933,
      "TP": 95,
      "FP": 0,
      "TN": 1836,
      "FN": 2,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 97.94,
      "f1_score": 98.96,
      "FPR": 0,
      "threshold_used": 0.0951920825988054,
      "val_threshold": 0.0949716418981552
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_21_66",
    "model_type": "ae",
    "equipment": "opcua_multi_21",
    "craft_id": "66",
    "data_size": 136320,
    "best_val_loss": 0.12088572502381086,
    "threshold": 0.4021412283182144,
    "trained_at": "2026-02-13T10:48:12.229616",
    "confusion_matrix": {
      "total_samples": 27264,
      "TP": 1358,
      "FP": 0,
      "TN": 25900,
      "FN": 6,
      "accuracy": 99.98,
      "precision": 100,
      "recall": 99.56,
      "f1_score": 99.78,
      "FPR": 0,
      "threshold_used": 0.4021412283182144,
      "val_threshold": 0.39424086660146684
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_35_DN8-GEAR4",
    "model_type": "ae",
    "equipment": "opcua_multi_35",
    "craft_id": "DN8-GEAR4",
    "data_size": 71960,
    "best_val_loss": 0.12263348391729968,
    "threshold": 0.118832066655159,
    "trained_at": "2026-02-13T11:05:03.565369",
    "confusion_matrix": {
      "total_samples": 14392,
      "TP": 720,
      "FP": 15,
      "TN": 13657,
      "FN": 0,
      "accuracy": 99.9,
      "precision": 97.96,
      "recall": 100,
      "f1_score": 98.97,
      "FPR": 0.11,
      "threshold_used": 0.118832066655159,
      "val_threshold": 0.12038289718329902
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_112",
    "model_type": "ae",
    "equipment": "opcua_multi_02",
    "craft_id": "112",
    "data_size": 35384,
    "best_val_loss": 0.12498111399415693,
    "threshold": 0.10194920226931546,
    "trained_at": "2026-02-13T11:07:29.236938",
    "confusion_matrix": {
      "total_samples": 7077,
      "TP": 354,
      "FP": 3,
      "TN": 6720,
      "FN": 0,
      "accuracy": 99.96,
      "precision": 99.16,
      "recall": 100,
      "f1_score": 99.58,
      "FPR": 0.04,
      "threshold_used": 0.10194920226931546,
      "val_threshold": 0.10280890911817547
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_91",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "91",
    "data_size": 2596,
    "best_val_loss": 0.12521601176032654,
    "threshold": 0.10404635407030582,
    "trained_at": "2026-02-13T11:32:36.818216",
    "confusion_matrix": {
      "total_samples": 520,
      "TP": 26,
      "FP": 8,
      "TN": 486,
      "FN": 0,
      "accuracy": 98.46,
      "precision": 76.47,
      "recall": 100,
      "f1_score": 86.67,
      "FPR": 1.62,
      "threshold_used": 0.10404635407030582,
      "val_threshold": 0.11382960341870783
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_110",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "110",
    "data_size": 10959,
    "best_val_loss": 0.1253296199397449,
    "threshold": 0.22110774815082546,
    "trained_at": "2026-02-13T11:43:39.676624",
    "confusion_matrix": {
      "total_samples": 2192,
      "TP": 110,
      "FP": 4,
      "TN": 2078,
      "FN": 0,
      "accuracy": 99.82,
      "precision": 96.49,
      "recall": 100,
      "f1_score": 98.21,
      "FPR": 0.19,
      "threshold_used": 0.22110774815082546,
      "val_threshold": 0.2226323142647742
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_24_111",
    "model_type": "ae",
    "equipment": "opcua_multi_24",
    "craft_id": "111",
    "data_size": 2917,
    "best_val_loss": 0.12613992740030158,
    "threshold": 0.13239870965480804,
    "trained_at": "2026-02-13T11:35:30.311500",
    "confusion_matrix": {
      "total_samples": 584,
      "TP": 30,
      "FP": 0,
      "TN": 554,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.13239870965480804,
      "val_threshold": 0.13344309031963356
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_104",
    "model_type": "ae",
    "equipment": "opcua_multi_10",
    "craft_id": "104",
    "data_size": 8457,
    "best_val_loss": 0.12624341128812333,
    "threshold": 0.11350204199552535,
    "trained_at": "2026-02-13T11:34:55.248545",
    "confusion_matrix": {
      "total_samples": 1692,
      "TP": 85,
      "FP": 0,
      "TN": 1607,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.11350204199552535,
      "val_threshold": 0.11344062089920029
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_33",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "33",
    "data_size": 56324,
    "best_val_loss": 0.12644939605978348,
    "threshold": 0.126171201467514,
    "trained_at": "2026-02-13T11:21:29.194953",
    "confusion_matrix": {
      "total_samples": 11265,
      "TP": 564,
      "FP": 7,
      "TN": 10694,
      "FN": 0,
      "accuracy": 99.94,
      "precision": 98.77,
      "recall": 100,
      "f1_score": 99.38,
      "FPR": 0.07,
      "threshold_used": 0.126171201467514,
      "val_threshold": 0.12707517445087427
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_120",
    "model_type": "ae",
    "equipment": "opcua_multi_18",
    "craft_id": "120",
    "data_size": 26454,
    "best_val_loss": 0.1272557918211166,
    "threshold": 0.19472265988588244,
    "trained_at": "2026-02-13T11:18:30.856683",
    "confusion_matrix": {
      "total_samples": 5291,
      "TP": 265,
      "FP": 22,
      "TN": 5004,
      "FN": 0,
      "accuracy": 99.58,
      "precision": 92.33,
      "recall": 100,
      "f1_score": 96.01,
      "FPR": 0.44,
      "threshold_used": 0.19472265988588244,
      "val_threshold": 0.20484649389982224
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_24",
    "model_type": "ae",
    "equipment": "opcua_multi_07",
    "craft_id": "24",
    "data_size": 91195,
    "best_val_loss": 0.12930170230396296,
    "threshold": 0.13069865480065346,
    "trained_at": "2026-02-13T11:02:47.509106",
    "confusion_matrix": {
      "total_samples": 18239,
      "TP": 901,
      "FP": 0,
      "TN": 17327,
      "FN": 11,
      "accuracy": 99.94,
      "precision": 100,
      "recall": 98.79,
      "f1_score": 99.39,
      "FPR": 0,
      "threshold_used": 0.13069865480065346,
      "val_threshold": 0.13043921738862987
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_105",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "105",
    "data_size": 5190,
    "best_val_loss": 0.1312752737661892,
    "threshold": 0.07897484265267847,
    "trained_at": "2026-02-13T11:47:12.472764",
    "confusion_matrix": {
      "total_samples": 1038,
      "TP": 45,
      "FP": 0,
      "TN": 986,
      "FN": 7,
      "accuracy": 99.33,
      "precision": 100,
      "recall": 86.54,
      "f1_score": 92.78,
      "FPR": 0,
      "threshold_used": 0.07897484265267847,
      "val_threshold": 0.07726936042308807
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_27",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "27",
    "data_size": 11166,
    "best_val_loss": 0.13190511313259548,
    "threshold": 0.09443890303373337,
    "trained_at": "2026-02-13T11:44:52.554762",
    "confusion_matrix": {
      "total_samples": 2234,
      "TP": 108,
      "FP": 0,
      "TN": 2122,
      "FN": 4,
      "accuracy": 99.82,
      "precision": 100,
      "recall": 96.43,
      "f1_score": 98.18,
      "FPR": 0,
      "threshold_used": 0.09443890303373337,
      "val_threshold": 0.09160785302519782
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_134",
    "model_type": "ae",
    "equipment": "opcua_multi_06",
    "craft_id": "134",
    "data_size": 55022,
    "best_val_loss": 0.1321658741555827,
    "threshold": 0.1331158012151718,
    "trained_at": "2026-02-13T11:18:08.686500",
    "confusion_matrix": {
      "total_samples": 11005,
      "TP": 541,
      "FP": 0,
      "TN": 10455,
      "FN": 9,
      "accuracy": 99.92,
      "precision": 100,
      "recall": 98.36,
      "f1_score": 99.17,
      "FPR": 0,
      "threshold_used": 0.1331158012151718,
      "val_threshold": 0.13115084171295166
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_11_103",
    "model_type": "ae",
    "equipment": "opcua_multi_11",
    "craft_id": "103",
    "data_size": 63940,
    "best_val_loss": 0.13328579947245206,
    "threshold": 0.19238578528165814,
    "trained_at": "2026-02-13T11:12:36.884996",
    "confusion_matrix": {
      "total_samples": 12788,
      "TP": 640,
      "FP": 23,
      "TN": 12125,
      "FN": 0,
      "accuracy": 99.82,
      "precision": 96.53,
      "recall": 100,
      "f1_score": 98.23,
      "FPR": 0.19,
      "threshold_used": 0.19238578528165814,
      "val_threshold": 0.19447138980031006
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_67-1",
    "model_type": "ae",
    "equipment": "opcua_multi_32",
    "craft_id": "67-1",
    "data_size": 9410,
    "best_val_loss": 0.13441419257415216,
    "threshold": 0.36594011634588175,
    "trained_at": "2026-02-13T11:11:09.857038",
    "confusion_matrix": {
      "total_samples": 1882,
      "TP": 92,
      "FP": 0,
      "TN": 1787,
      "FN": 3,
      "accuracy": 99.84,
      "precision": 100,
      "recall": 96.84,
      "f1_score": 98.39,
      "FPR": 0,
      "threshold_used": 0.36594011634588175,
      "val_threshold": 0.34845681190490657
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_72",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "72",
    "data_size": 49630,
    "best_val_loss": 0.13457576903876173,
    "threshold": 0.1365145891904831,
    "trained_at": "2026-02-13T11:24:32.807264",
    "confusion_matrix": {
      "total_samples": 9926,
      "TP": 497,
      "FP": 49,
      "TN": 9380,
      "FN": 0,
      "accuracy": 99.51,
      "precision": 91.03,
      "recall": 100,
      "f1_score": 95.3,
      "FPR": 0.52,
      "threshold_used": 0.1365145891904831,
      "val_threshold": 0.1411224603652954
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_13_36",
    "model_type": "ae",
    "equipment": "opcua_multi_13",
    "craft_id": "36",
    "data_size": 58880,
    "best_val_loss": 0.1366224056109786,
    "threshold": 0.14854269623756405,
    "trained_at": "2026-02-13T11:10:04.664137",
    "confusion_matrix": {
      "total_samples": 11776,
      "TP": 589,
      "FP": 2,
      "TN": 11185,
      "FN": 0,
      "accuracy": 99.98,
      "precision": 99.66,
      "recall": 100,
      "f1_score": 99.83,
      "FPR": 0.02,
      "threshold_used": 0.14854269623756405,
      "val_threshold": 0.1494559496641159
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_92",
    "model_type": "ae",
    "equipment": "opcua_multi_34",
    "craft_id": "92",
    "data_size": 13504,
    "best_val_loss": 0.1377614853198177,
    "threshold": 0.12616972029209136,
    "trained_at": "2026-02-13T11:44:13.078434",
    "confusion_matrix": {
      "total_samples": 2701,
      "TP": 128,
      "FP": 0,
      "TN": 2566,
      "FN": 7,
      "accuracy": 99.74,
      "precision": 100,
      "recall": 94.81,
      "f1_score": 97.34,
      "FPR": 0,
      "threshold_used": 0.12616972029209136,
      "val_threshold": 0.12379181385040283
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_70",
    "model_type": "ae",
    "equipment": "opcua_multi_33",
    "craft_id": "70",
    "data_size": 49881,
    "best_val_loss": 0.13850731125656487,
    "threshold": 0.19069495797157288,
    "trained_at": "2026-02-13T11:19:47.605583",
    "confusion_matrix": {
      "total_samples": 9977,
      "TP": 499,
      "FP": 24,
      "TN": 9454,
      "FN": 0,
      "accuracy": 99.76,
      "precision": 95.41,
      "recall": 100,
      "f1_score": 97.65,
      "FPR": 0.25,
      "threshold_used": 0.19069495797157288,
      "val_threshold": 0.19159650802612305
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_84",
    "model_type": "ae",
    "equipment": "opcua_multi_40",
    "craft_id": "84",
    "data_size": 7318,
    "best_val_loss": 0.1394896376979807,
    "threshold": 0.2587828144431111,
    "trained_at": "2026-02-13T11:46:10.725210",
    "confusion_matrix": {
      "total_samples": 1464,
      "TP": 73,
      "FP": 0,
      "TN": 1390,
      "FN": 1,
      "accuracy": 99.93,
      "precision": 100,
      "recall": 98.65,
      "f1_score": 99.32,
      "FPR": 0,
      "threshold_used": 0.2587828144431111,
      "val_threshold": 0.256132903695106
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_105",
    "model_type": "ae",
    "equipment": "opcua_multi_09",
    "craft_id": "105",
    "data_size": 5617,
    "best_val_loss": 0.14136469559047996,
    "threshold": 0.12743901312351177,
    "trained_at": "2026-02-13T11:46:55.842936",
    "confusion_matrix": {
      "total_samples": 1124,
      "TP": 57,
      "FP": 1,
      "TN": 1066,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.28,
      "recall": 100,
      "f1_score": 99.13,
      "FPR": 0.09,
      "threshold_used": 0.12743901312351177,
      "val_threshold": 0.13653600364923466
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_12_32",
    "model_type": "ae",
    "equipment": "opcua_multi_12",
    "craft_id": "32",
    "data_size": 17022,
    "best_val_loss": 0.14284175086257742,
    "threshold": 0.11682941615581503,
    "trained_at": "2026-02-13T11:36:44.291765",
    "confusion_matrix": {
      "total_samples": 3405,
      "TP": 169,
      "FP": 0,
      "TN": 3234,
      "FN": 2,
      "accuracy": 99.94,
      "precision": 100,
      "recall": 98.83,
      "f1_score": 99.41,
      "FPR": 0,
      "threshold_used": 0.11682941615581503,
      "val_threshold": 0.11595328003168086
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_06_30",
    "model_type": "ae",
    "equipment": "opcua_multi_06",
    "craft_id": "30",
    "data_size": 17336,
    "best_val_loss": 0.14581238271748043,
    "threshold": 0.1658269613981247,
    "trained_at": "2026-02-13T11:34:10.279314",
    "confusion_matrix": {
      "total_samples": 3468,
      "TP": 174,
      "FP": 40,
      "TN": 3254,
      "FN": 0,
      "accuracy": 98.85,
      "precision": 81.31,
      "recall": 100,
      "f1_score": 89.69,
      "FPR": 1.21,
      "threshold_used": 0.1658269613981247,
      "val_threshold": 0.1773630850017069
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_67-2",
    "model_type": "ae",
    "equipment": "opcua_multi_32",
    "craft_id": "67-2",
    "data_size": 7681,
    "best_val_loss": 0.1469234192571812,
    "threshold": 0.10342707484960556,
    "trained_at": "2026-02-13T11:07:51.093271",
    "confusion_matrix": {
      "total_samples": 1537,
      "TP": 68,
      "FP": 0,
      "TN": 1460,
      "FN": 9,
      "accuracy": 99.41,
      "precision": 100,
      "recall": 88.31,
      "f1_score": 93.79,
      "FPR": 0,
      "threshold_used": 0.10342707484960556,
      "val_threshold": 0.09434918612241742
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_28_61-1",
    "model_type": "ae",
    "equipment": "opcua_multi_28",
    "craft_id": "61-1",
    "data_size": 15484,
    "best_val_loss": 0.14760008516631512,
    "threshold": 0.28887183666229194,
    "trained_at": "2026-02-13T11:27:10.216510",
    "confusion_matrix": {
      "total_samples": 3097,
      "TP": 140,
      "FP": 0,
      "TN": 2942,
      "FN": 15,
      "accuracy": 99.52,
      "precision": 100,
      "recall": 90.32,
      "f1_score": 94.91,
      "FPR": 0,
      "threshold_used": 0.28887183666229194,
      "val_threshold": 0.28040811419487
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_36",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "36",
    "data_size": 47470,
    "best_val_loss": 0.15120377119654904,
    "threshold": 0.07829847931861877,
    "trained_at": "2026-02-13T11:28:41.492022",
    "confusion_matrix": {
      "total_samples": 9494,
      "TP": 471,
      "FP": 0,
      "TN": 9019,
      "FN": 4,
      "accuracy": 99.96,
      "precision": 100,
      "recall": 99.16,
      "f1_score": 99.58,
      "FPR": 0,
      "threshold_used": 0.07829847931861877,
      "val_threshold": 0.07787280194461349
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_73",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "73",
    "data_size": 20981,
    "best_val_loss": 0.15195165671566171,
    "threshold": 0.18539040088653558,
    "trained_at": "2026-02-13T11:35:10.432086",
    "confusion_matrix": {
      "total_samples": 4197,
      "TP": 210,
      "FP": 12,
      "TN": 3975,
      "FN": 0,
      "accuracy": 99.71,
      "precision": 94.59,
      "recall": 100,
      "f1_score": 97.22,
      "FPR": 0.3,
      "threshold_used": 0.18539040088653558,
      "val_threshold": 0.1868279993534087
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_05_65-2",
    "model_type": "ae",
    "equipment": "opcua_multi_05",
    "craft_id": "65-2",
    "data_size": 40690,
    "best_val_loss": 0.15265421725078981,
    "threshold": 0.20710781365633008,
    "trained_at": "2026-02-13T11:31:14.447054",
    "confusion_matrix": {
      "total_samples": 8138,
      "TP": 407,
      "FP": 17,
      "TN": 7714,
      "FN": 0,
      "accuracy": 99.79,
      "precision": 95.99,
      "recall": 100,
      "f1_score": 97.95,
      "FPR": 0.22,
      "threshold_used": 0.20710781365633008,
      "val_threshold": 0.2126486107707023
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_39-2",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "39-2",
    "data_size": 4244,
    "best_val_loss": 0.1538989746546015,
    "threshold": 0.22253416329622228,
    "trained_at": "2026-02-13T11:36:01.775043",
    "confusion_matrix": {
      "total_samples": 849,
      "TP": 37,
      "FP": 0,
      "TN": 806,
      "FN": 6,
      "accuracy": 99.29,
      "precision": 100,
      "recall": 86.05,
      "f1_score": 92.5,
      "FPR": 0,
      "threshold_used": 0.22253416329622228,
      "val_threshold": 0.18385204970836633
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_05_11",
    "model_type": "ae",
    "equipment": "opcua_multi_05",
    "craft_id": "11",
    "data_size": 123876,
    "best_val_loss": 0.15787302903905584,
    "threshold": 0.1109293058514591,
    "trained_at": "2026-02-13T10:58:38.497993",
    "confusion_matrix": {
      "total_samples": 24776,
      "TP": 1200,
      "FP": 0,
      "TN": 23537,
      "FN": 39,
      "accuracy": 99.84,
      "precision": 100,
      "recall": 96.85,
      "f1_score": 98.4,
      "FPR": 0,
      "threshold_used": 0.1109293058514591,
      "val_threshold": 0.10812393389642239
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_104",
    "model_type": "ae",
    "equipment": "opcua_multi_18",
    "craft_id": "104",
    "data_size": 13585,
    "best_val_loss": 0.15789406587989135,
    "threshold": 0.10231645442545396,
    "trained_at": "2026-02-13T11:43:57.538381",
    "confusion_matrix": {
      "total_samples": 2717,
      "TP": 136,
      "FP": 7,
      "TN": 2574,
      "FN": 0,
      "accuracy": 99.74,
      "precision": 95.1,
      "recall": 100,
      "f1_score": 97.49,
      "FPR": 0.27,
      "threshold_used": 0.10231645442545396,
      "val_threshold": 0.10475095957517615
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_45",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "45",
    "data_size": 45282,
    "best_val_loss": 0.1604923122437325,
    "threshold": 0.28642320632934437,
    "trained_at": "2026-02-13T11:09:17.534979",
    "confusion_matrix": {
      "total_samples": 9057,
      "TP": 444,
      "FP": 0,
      "TN": 8604,
      "FN": 9,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 98.01,
      "f1_score": 99,
      "FPR": 0,
      "threshold_used": 0.28642320632934437,
      "val_threshold": 0.2813152849674199
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_54",
    "model_type": "ae",
    "equipment": "opcua_multi_18",
    "craft_id": "54",
    "data_size": 46354,
    "best_val_loss": 0.1617707524530203,
    "threshold": 0.20180521011352545,
    "trained_at": "2026-02-13T11:27:10.583195",
    "confusion_matrix": {
      "total_samples": 9271,
      "TP": 440,
      "FP": 0,
      "TN": 8807,
      "FN": 24,
      "accuracy": 99.74,
      "precision": 100,
      "recall": 94.83,
      "f1_score": 97.35,
      "FPR": 0,
      "threshold_used": 0.20180521011352545,
      "val_threshold": 0.1928514689207077
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_73",
    "model_type": "ae",
    "equipment": "opcua_multi_33",
    "craft_id": "73",
    "data_size": 4919,
    "best_val_loss": 0.16427897065272176,
    "threshold": 0.10992455780506132,
    "trained_at": "2026-02-13T11:39:42.961261",
    "confusion_matrix": {
      "total_samples": 984,
      "TP": 43,
      "FP": 0,
      "TN": 934,
      "FN": 7,
      "accuracy": 99.29,
      "precision": 100,
      "recall": 86,
      "f1_score": 92.47,
      "FPR": 0,
      "threshold_used": 0.10992455780506132,
      "val_threshold": 0.10467316806316367
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_25_60",
    "model_type": "ae",
    "equipment": "opcua_multi_25",
    "craft_id": "60",
    "data_size": 63319,
    "best_val_loss": 0.16613198047949781,
    "threshold": 0.11531566828489304,
    "trained_at": "2026-02-13T10:43:48.542694",
    "confusion_matrix": {
      "total_samples": 12664,
      "TP": 615,
      "FP": 0,
      "TN": 12030,
      "FN": 19,
      "accuracy": 99.85,
      "precision": 100,
      "recall": 97,
      "f1_score": 98.48,
      "FPR": 0,
      "threshold_used": 0.11531566828489304,
      "val_threshold": 0.11385256685316558
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_01_MA120IIIE.09",
    "model_type": "ae",
    "equipment": "opcua_multi_dongtan_01",
    "craft_id": "MA120IIIE.09",
    "data_size": 212960,
    "best_val_loss": 0.16657866802343652,
    "threshold": 0.19152273461222644,
    "trained_at": "2026-02-13T10:42:41.009828",
    "confusion_matrix": {
      "total_samples": 42592,
      "TP": 2078,
      "FP": 0,
      "TN": 40462,
      "FN": 52,
      "accuracy": 99.88,
      "precision": 100,
      "recall": 97.56,
      "f1_score": 98.76,
      "FPR": 0,
      "threshold_used": 0.19152273461222644,
      "val_threshold": 0.1899377577006816
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_96",
    "model_type": "ae",
    "equipment": "opcua_multi_32",
    "craft_id": "96",
    "data_size": 3002,
    "best_val_loss": 0.16692911237540242,
    "threshold": 0.1386653631925583,
    "trained_at": "2026-02-13T11:26:30.189775",
    "confusion_matrix": {
      "total_samples": 601,
      "TP": 30,
      "FP": 0,
      "TN": 571,
      "FN": 0,
      "accuracy": 100,
      "precision": 100,
      "recall": 100,
      "f1_score": 100,
      "FPR": 0,
      "threshold_used": 0.1386653631925583,
      "val_threshold": 0.13291482627391815
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_33_67-2",
    "model_type": "ae",
    "equipment": "opcua_multi_33",
    "craft_id": "67-2",
    "data_size": 38628,
    "best_val_loss": 0.17033625627671872,
    "threshold": 0.16198389306664462,
    "trained_at": "2026-02-13T11:23:11.231789",
    "confusion_matrix": {
      "total_samples": 7726,
      "TP": 387,
      "FP": 31,
      "TN": 7308,
      "FN": 0,
      "accuracy": 99.6,
      "precision": 92.58,
      "recall": 100,
      "f1_score": 96.15,
      "FPR": 0.42,
      "threshold_used": 0.16198389306664462,
      "val_threshold": 0.16716835647821426
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_16_57",
    "model_type": "ae",
    "equipment": "opcua_multi_16",
    "craft_id": "57",
    "data_size": 15326,
    "best_val_loss": 0.1760110970579248,
    "threshold": 0.19612380415201183,
    "trained_at": "2026-02-13T10:37:04.952321",
    "confusion_matrix": {
      "total_samples": 3066,
      "TP": 152,
      "FP": 0,
      "TN": 2912,
      "FN": 2,
      "accuracy": 99.93,
      "precision": 100,
      "recall": 98.7,
      "f1_score": 99.35,
      "FPR": 0,
      "threshold_used": 0.19612380415201183,
      "val_threshold": 0.19423235952854156
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_32_113",
    "model_type": "ae",
    "equipment": "opcua_multi_32",
    "craft_id": "113",
    "data_size": 2985,
    "best_val_loss": 0.1768759346787055,
    "threshold": 0.14008391276001933,
    "trained_at": "2026-02-13T11:37:01.861093",
    "confusion_matrix": {
      "total_samples": 597,
      "TP": 30,
      "FP": 11,
      "TN": 556,
      "FN": 0,
      "accuracy": 98.16,
      "precision": 73.17,
      "recall": 100,
      "f1_score": 84.51,
      "FPR": 1.94,
      "threshold_used": 0.14008391276001933,
      "val_threshold": 0.2042339235544198
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_2",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "2",
    "data_size": 5989,
    "best_val_loss": 0.1772649745536169,
    "threshold": 0.11474210023880005,
    "trained_at": "2026-02-13T11:46:43.122743",
    "confusion_matrix": {
      "total_samples": 1198,
      "TP": 60,
      "FP": 4,
      "TN": 1134,
      "FN": 0,
      "accuracy": 99.67,
      "precision": 93.75,
      "recall": 100,
      "f1_score": 96.77,
      "FPR": 0.35,
      "threshold_used": 0.11474210023880005,
      "val_threshold": 0.12041977308690532
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_MAHIND-GEA3",
    "model_type": "ae",
    "equipment": "opcua_multi_27",
    "craft_id": "MAHIND-GEA3",
    "data_size": 24463,
    "best_val_loss": 0.1811939203194648,
    "threshold": 0.2708180010318756,
    "trained_at": "2026-02-13T11:10:40.460033",
    "confusion_matrix": {
      "total_samples": 4893,
      "TP": 242,
      "FP": 0,
      "TN": 4648,
      "FN": 3,
      "accuracy": 99.94,
      "precision": 100,
      "recall": 98.78,
      "f1_score": 99.39,
      "FPR": 0,
      "threshold_used": 0.2708180010318756,
      "val_threshold": 0.27043457627296447
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_34_71",
    "model_type": "ae",
    "equipment": "opcua_multi_34",
    "craft_id": "71",
    "data_size": 55927,
    "best_val_loss": 0.18911680254546384,
    "threshold": 0.17197225987911224,
    "trained_at": "2026-02-13T10:59:38.667062",
    "confusion_matrix": {
      "total_samples": 11186,
      "TP": 549,
      "FP": 0,
      "TN": 10626,
      "FN": 11,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 98.04,
      "f1_score": 99.01,
      "FPR": 0,
      "threshold_used": 0.17197225987911224,
      "val_threshold": 0.16976115852594376
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_04_MA120IIIE.09",
    "model_type": "ae",
    "equipment": "opcua_multi_dongtan_04",
    "craft_id": "MA120IIIE.09",
    "data_size": 336221,
    "best_val_loss": 0.19119272991118533,
    "threshold": 0.24990437179803848,
    "trained_at": "2026-02-13T10:29:43.138528",
    "confusion_matrix": {
      "total_samples": 67245,
      "TP": 3363,
      "FP": 16,
      "TN": 63866,
      "FN": 0,
      "accuracy": 99.98,
      "precision": 99.53,
      "recall": 100,
      "f1_score": 99.76,
      "FPR": 0.03,
      "threshold_used": 0.24990437179803848,
      "val_threshold": 0.2516481876373291
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_31",
    "model_type": "ae",
    "equipment": "opcua_multi_09",
    "craft_id": "31",
    "data_size": 35367,
    "best_val_loss": 0.19233688708117766,
    "threshold": 0.22991706430912004,
    "trained_at": "2026-02-13T11:22:36.318886",
    "confusion_matrix": {
      "total_samples": 7074,
      "TP": 354,
      "FP": 11,
      "TN": 6709,
      "FN": 0,
      "accuracy": 99.84,
      "precision": 96.99,
      "recall": 100,
      "f1_score": 98.47,
      "FPR": 0.16,
      "threshold_used": 0.22991706430912004,
      "val_threshold": 0.23503497540950774
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_22_109",
    "model_type": "ae",
    "equipment": "opcua_multi_22",
    "craft_id": "109",
    "data_size": 77744,
    "best_val_loss": 0.19274874265090133,
    "threshold": 0.13897424936294556,
    "trained_at": "2026-02-13T10:50:43.000117",
    "confusion_matrix": {
      "total_samples": 15549,
      "TP": 743,
      "FP": 0,
      "TN": 14771,
      "FN": 35,
      "accuracy": 99.77,
      "precision": 100,
      "recall": 95.5,
      "f1_score": 97.7,
      "FPR": 0,
      "threshold_used": 0.13897424936294556,
      "val_threshold": 0.13569836318492887
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_08_34",
    "model_type": "ae",
    "equipment": "opcua_multi_08",
    "craft_id": "34",
    "data_size": 17310,
    "best_val_loss": 0.1935403718253149,
    "threshold": 0.1596803441643715,
    "trained_at": "2026-02-13T11:40:08.416062",
    "confusion_matrix": {
      "total_samples": 3462,
      "TP": 162,
      "FP": 0,
      "TN": 3288,
      "FN": 12,
      "accuracy": 99.65,
      "precision": 100,
      "recall": 93.1,
      "f1_score": 96.43,
      "FPR": 0,
      "threshold_used": 0.1596803441643715,
      "val_threshold": 0.15477089658379553
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_35_63-1",
    "model_type": "ae",
    "equipment": "opcua_multi_35",
    "craft_id": "63-1",
    "data_size": 50141,
    "best_val_loss": 0.19665745817743682,
    "threshold": 0.21116995587944942,
    "trained_at": "2026-02-13T11:21:58.659500",
    "confusion_matrix": {
      "total_samples": 10029,
      "TP": 502,
      "FP": 22,
      "TN": 9505,
      "FN": 0,
      "accuracy": 99.78,
      "precision": 95.8,
      "recall": 100,
      "f1_score": 97.85,
      "FPR": 0.23,
      "threshold_used": 0.21116995587944942,
      "val_threshold": 0.2220079809427263
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_27_96",
    "model_type": "ae",
    "equipment": "opcua_multi_27",
    "craft_id": "96",
    "data_size": 2396,
    "best_val_loss": 0.20644537210464478,
    "threshold": 0.0968027301132679,
    "trained_at": "2026-02-13T11:42:18.327850",
    "confusion_matrix": {
      "total_samples": 480,
      "TP": 24,
      "FP": 18,
      "TN": 438,
      "FN": 0,
      "accuracy": 96.25,
      "precision": 57.14,
      "recall": 100,
      "f1_score": 72.72,
      "FPR": 3.95,
      "threshold_used": 0.0968027301132679,
      "val_threshold": 0.1359054937958713
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_18_96",
    "model_type": "ae",
    "equipment": "opcua_multi_18",
    "craft_id": "96",
    "data_size": 2842,
    "best_val_loss": 0.20900287239538973,
    "threshold": 0.08579088896512989,
    "trained_at": "2026-02-13T11:32:20.019919",
    "confusion_matrix": {
      "total_samples": 569,
      "TP": 29,
      "FP": 2,
      "TN": 538,
      "FN": 0,
      "accuracy": 99.65,
      "precision": 93.55,
      "recall": 100,
      "f1_score": 96.67,
      "FPR": 0.37,
      "threshold_used": 0.08579088896512989,
      "val_threshold": 0.09030681550502777
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_21",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "21",
    "data_size": 29686,
    "best_val_loss": 0.21265526584033695,
    "threshold": 0.11734562925994385,
    "trained_at": "2026-02-13T11:34:10.365071",
    "confusion_matrix": {
      "total_samples": 5938,
      "TP": 270,
      "FP": 0,
      "TN": 5641,
      "FN": 27,
      "accuracy": 99.55,
      "precision": 100,
      "recall": 90.91,
      "f1_score": 95.24,
      "FPR": 0,
      "threshold_used": 0.11734562925994385,
      "val_threshold": 0.10468601584434489
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_23_12",
    "model_type": "ae",
    "equipment": "opcua_multi_23",
    "craft_id": "12",
    "data_size": 23044,
    "best_val_loss": 0.22835157464896294,
    "threshold": 0.37644341588020325,
    "trained_at": "2026-02-13T10:52:51.057676",
    "confusion_matrix": {
      "total_samples": 4609,
      "TP": 231,
      "FP": 1,
      "TN": 4377,
      "FN": 0,
      "accuracy": 99.98,
      "precision": 99.57,
      "recall": 100,
      "f1_score": 99.78,
      "FPR": 0.02,
      "threshold_used": 0.37644341588020325,
      "val_threshold": 0.37675884366035456
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_19_105",
    "model_type": "ae",
    "equipment": "opcua_multi_19",
    "craft_id": "105",
    "data_size": 16586,
    "best_val_loss": 0.2315477894135201,
    "threshold": 0.0938094716519117,
    "trained_at": "2026-02-13T11:41:27.129929",
    "confusion_matrix": {
      "total_samples": 3318,
      "TP": 166,
      "FP": 11,
      "TN": 3141,
      "FN": 0,
      "accuracy": 99.67,
      "precision": 93.79,
      "recall": 100,
      "f1_score": 96.8,
      "FPR": 0.35,
      "threshold_used": 0.0938094716519117,
      "val_threshold": 0.09549858868122099
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_04_65",
    "model_type": "ae",
    "equipment": "opcua_multi_04",
    "craft_id": "65",
    "data_size": 96279,
    "best_val_loss": 0.23281699129139233,
    "threshold": 0.3280024319887157,
    "trained_at": "2026-02-13T10:50:19.790442",
    "confusion_matrix": {
      "total_samples": 19256,
      "TP": 963,
      "FP": 71,
      "TN": 18222,
      "FN": 0,
      "accuracy": 99.63,
      "precision": 93.13,
      "recall": 100,
      "f1_score": 96.44,
      "FPR": 0.39,
      "threshold_used": 0.3280024319887157,
      "val_threshold": 0.33652058243751526
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_12_35-1",
    "model_type": "ae",
    "equipment": "opcua_multi_12",
    "craft_id": "35-1",
    "data_size": 45715,
    "best_val_loss": 0.23466402399817662,
    "threshold": 0.23354296386241913,
    "trained_at": "2026-02-13T10:52:51.068584",
    "confusion_matrix": {
      "total_samples": 9143,
      "TP": 403,
      "FP": 0,
      "TN": 8685,
      "FN": 55,
      "accuracy": 99.4,
      "precision": 100,
      "recall": 87.99,
      "f1_score": 93.61,
      "FPR": 0,
      "threshold_used": 0.23354296386241913,
      "val_threshold": 0.21681039482355113
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_39_131",
    "model_type": "ae",
    "equipment": "opcua_multi_39",
    "craft_id": "131",
    "data_size": 10895,
    "best_val_loss": 0.23973925776494143,
    "threshold": 0.10140791721642017,
    "trained_at": "2026-02-13T11:45:08.832453",
    "confusion_matrix": {
      "total_samples": 2179,
      "TP": 109,
      "FP": 1,
      "TN": 2069,
      "FN": 0,
      "accuracy": 99.95,
      "precision": 99.09,
      "recall": 100,
      "f1_score": 99.54,
      "FPR": 0.05,
      "threshold_used": 0.10140791721642017,
      "val_threshold": 0.10157135874032967
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_40_85",
    "model_type": "ae",
    "equipment": "opcua_multi_40",
    "craft_id": "85",
    "data_size": 6284,
    "best_val_loss": 0.24708223009190108,
    "threshold": 0.20379919707775093,
    "trained_at": "2026-02-13T11:46:27.670405",
    "confusion_matrix": {
      "total_samples": 1257,
      "TP": 63,
      "FP": 2,
      "TN": 1192,
      "FN": 0,
      "accuracy": 99.84,
      "precision": 96.92,
      "recall": 100,
      "f1_score": 98.44,
      "FPR": 0.17,
      "threshold_used": 0.20379919707775093,
      "val_threshold": 0.20533718466758732
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_31_67-1",
    "model_type": "ae",
    "equipment": "opcua_multi_31",
    "craft_id": "67-1",
    "data_size": 42167,
    "best_val_loss": 0.24996679870401595,
    "threshold": 0.19464224576950073,
    "trained_at": "2026-02-13T11:11:57.555917",
    "confusion_matrix": {
      "total_samples": 8434,
      "TP": 422,
      "FP": 24,
      "TN": 7988,
      "FN": 0,
      "accuracy": 99.72,
      "precision": 94.62,
      "recall": 100,
      "f1_score": 97.24,
      "FPR": 0.3,
      "threshold_used": 0.19464224576950073,
      "val_threshold": 0.2054977767169474
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_10_99",
    "model_type": "ae",
    "equipment": "opcua_multi_10",
    "craft_id": "99",
    "data_size": 45832,
    "best_val_loss": 0.25508688669844776,
    "threshold": 0.2059309899806976,
    "trained_at": "2026-02-13T11:29:57.789047",
    "confusion_matrix": {
      "total_samples": 9167,
      "TP": 459,
      "FP": 8,
      "TN": 8700,
      "FN": 0,
      "accuracy": 99.91,
      "precision": 98.29,
      "recall": 100,
      "f1_score": 99.14,
      "FPR": 0.09,
      "threshold_used": 0.2059309899806976,
      "val_threshold": 0.20810899734497057
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_29_121",
    "model_type": "ae",
    "equipment": "opcua_multi_29",
    "craft_id": "121",
    "data_size": 16297,
    "best_val_loss": 0.2627548197295768,
    "threshold": 0.10220265090465534,
    "trained_at": "2026-02-13T11:39:15.208909",
    "confusion_matrix": {
      "total_samples": 3260,
      "TP": 163,
      "FP": 15,
      "TN": 3082,
      "FN": 0,
      "accuracy": 99.54,
      "precision": 91.57,
      "recall": 100,
      "f1_score": 95.6,
      "FPR": 0.48,
      "threshold_used": 0.10220265090465534,
      "val_threshold": 0.10466558225452899
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_02_64-2",
    "model_type": "ae",
    "equipment": "opcua_multi_02",
    "craft_id": "64-2",
    "data_size": 72959,
    "best_val_loss": 0.26627106155808034,
    "threshold": 0.14111705869436253,
    "trained_at": "2026-02-13T11:10:45.690194",
    "confusion_matrix": {
      "total_samples": 14592,
      "TP": 715,
      "FP": 0,
      "TN": 13862,
      "FN": 15,
      "accuracy": 99.9,
      "precision": 100,
      "recall": 97.95,
      "f1_score": 98.96,
      "FPR": 0,
      "threshold_used": 0.14111705869436253,
      "val_threshold": 0.13857361674308777
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_30_69",
    "model_type": "ae",
    "equipment": "opcua_multi_30",
    "craft_id": "69",
    "data_size": 77867,
    "best_val_loss": 0.29511117867630776,
    "threshold": 0.15623030364513393,
    "trained_at": "2026-02-13T11:01:26.693196",
    "confusion_matrix": {
      "total_samples": 15574,
      "TP": 754,
      "FP": 0,
      "TN": 14795,
      "FN": 25,
      "accuracy": 99.84,
      "precision": 100,
      "recall": 96.79,
      "f1_score": 98.37,
      "FPR": 0,
      "threshold_used": 0.15623030364513393,
      "val_threshold": 0.15530174449086187
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_36_125-1",
    "model_type": "ae",
    "equipment": "opcua_multi_36",
    "craft_id": "125-1",
    "data_size": 51566,
    "best_val_loss": 0.33307149289192123,
    "threshold": 0.11224538050591934,
    "trained_at": "2026-02-13T11:06:18.542969",
    "confusion_matrix": {
      "total_samples": 10314,
      "TP": 516,
      "FP": 1,
      "TN": 9797,
      "FN": 0,
      "accuracy": 99.99,
      "precision": 99.81,
      "recall": 100,
      "f1_score": 99.9,
      "FPR": 0.01,
      "threshold_used": 0.11224538050591934,
      "val_threshold": 0.11244363412261009
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_09_36",
    "model_type": "ae",
    "equipment": "opcua_multi_09",
    "craft_id": "36",
    "data_size": 4382,
    "best_val_loss": 0.37994011704350145,
    "threshold": 0.056798141449689865,
    "trained_at": "2026-02-13T11:32:45.129243",
    "confusion_matrix": {
      "total_samples": 877,
      "TP": 44,
      "FP": 11,
      "TN": 822,
      "FN": 0,
      "accuracy": 98.75,
      "precision": 80,
      "recall": 100,
      "f1_score": 88.89,
      "FPR": 1.32,
      "threshold_used": 0.056798141449689865,
      "val_threshold": 0.06857270598411558
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_dongtan_03_MA120IIIE.09",
    "model_type": "ae",
    "equipment": "opcua_multi_dongtan_03",
    "craft_id": "MA120IIIE.09",
    "data_size": 289200,
    "best_val_loss": 0.38583447395271286,
    "threshold": 0.25519720315933225,
    "trained_at": "2026-02-13T10:31:27.944936",
    "confusion_matrix": {
      "total_samples": 57840,
      "TP": 2892,
      "FP": 33,
      "TN": 54915,
      "FN": 0,
      "accuracy": 99.94,
      "precision": 98.87,
      "recall": 100,
      "f1_score": 99.43,
      "FPR": 0.06,
      "threshold_used": 0.25519720315933225,
      "val_threshold": 0.25753635317087165
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_31_67-3",
    "model_type": "ae",
    "equipment": "opcua_multi_31",
    "craft_id": "67-3",
    "data_size": 113317,
    "best_val_loss": 0.4135546108495419,
    "threshold": 0.15776999890804283,
    "trained_at": "2026-02-13T10:52:06.564482",
    "confusion_matrix": {
      "total_samples": 22664,
      "TP": 1134,
      "FP": 25,
      "TN": 21505,
      "FN": 0,
      "accuracy": 99.89,
      "precision": 97.84,
      "recall": 100,
      "f1_score": 98.91,
      "FPR": 0.12,
      "threshold_used": 0.15776999890804283,
      "val_threshold": 0.1589307598769663
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_20_90",
    "model_type": "ae",
    "equipment": "opcua_multi_20",
    "craft_id": "90",
    "data_size": 2891,
    "best_val_loss": 0.5036840293498546,
    "threshold": 0.2898161217570302,
    "trained_at": "2026-02-13T11:45:21.987819",
    "confusion_matrix": {
      "total_samples": 579,
      "TP": 29,
      "FP": 1,
      "TN": 549,
      "FN": 0,
      "accuracy": 99.83,
      "precision": 96.67,
      "recall": 100,
      "f1_score": 98.31,
      "FPR": 0.18,
      "threshold_used": 0.2898161217570302,
      "val_threshold": 0.2948759019374851
    },
    "training_history": []
  },
  {
    "model_id": "opcua_multi_07_32",
    "model_type": "ae",
    "equipment": "opcua_multi_07",
    "craft_id": "32",
    "data_size": 51414,
    "best_val_loss": 0.5153460933907561,
    "threshold": 0.17418886721134186,
    "trained_at": "2026-02-13T11:24:49.916237",
    "confusion_matrix": {
      "total_samples": 10283,
      "TP": 515,
      "FP": 31,
      "TN": 9737,
      "FN": 0,
      "accuracy": 99.7,
      "precision": 94.32,
      "recall": 100,
      "f1_score": 97.08,
      "FPR": 0.32,
      "threshold_used": 0.17418886721134186,
      "val_threshold": 0.17769251614809037
    },
    "training_history": []
  }
]
  }
};
